import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import VoiceActivityDetectionManager from "models/audioEditor/VoiceActivityDetectionManager";
import SequencerNodeUtils from 'models/audioEditor/SequencerNodeUtils';
import SequencerRendererUtils from 'models/audioEditor/SequencerRendererUtils';
import TrebbleClientAPIHelper from "models/helper/TrebbleClientAPI";
import ti18n from "i18n!nls/Sequenceri18n";
import RSVP from "rsvp";

const SEARCH_TYPE = {
    "TEXT_SEARCH":"textSearch",
    "DISFLUENCY_SEARCH":"disfluenySearch",
    "FILLER_WORDS":"fillerWordSearch",
    "SILENCES":"silenceSearch",
    "EDIT_BOUNDARIES":"editBoundaries",
    "SEMANTIC_SEARCH":"semanticSearch",
    "AI_EDIT_SUGGESTIONS":"aiEditSuggestions",
}

const MEDIA_ANALYSIS_REASON = {
    "SILENCE": "silence",
    "SAFE_CUT": "safeCut",
    "IMPROVE_SAFETY": "improveSafety"
}

// Long silences constants
const LONG_SILENCE_THRESHOLD_MS = 1000; // 1 seconds
const ENABLE_LONG_SILENCES_IN_AI_SUGGESTIONS = false;

// Feature flag to control default safety improvement for AI suggestions
const ENABLE_IMPROVE_SAFETY_BY_DEFAULT_FOR_AI_SUGGESTIONS = true;

const TIMEOUT_DELAY = 100;
const SAFE_TRIM_LEFT_BUFFER = 40;
const SAFE_TRIM_RIGHT_BUFFER = 40;
const SAFE_TRIM_LEFT_SILENCE = 0;
const SAFE_TRIM_RIGHT_SILENCE = 0;
const SUGGESTION_FEEDBACK_ACTION = {
    APPLIED: "applied",
    DISMISSED: "dismissed",
    UNDONE: "undone"
};
const SUGGESTION_FEEDBACK_FLUSH_DELAY_MS = 500;
const SUGGESTION_FEEDBACK_BATCH_SIZE = 20;
const SUGGESTION_FEEDBACK_MAX_RETRY_COUNT = 3;
const SequencerSearchWidget =  Backbone.Model.extend({

    constructor: function(attributes, options) {

        Backbone.Model.apply(this, [attributes, options]);
        //this._nodesInClipboard =  new Backbone.Collection();
        this._sequencer = attributes.sequencer;
        this.set("searchParams", null);
        this.set("indexOfNodeInFocus", -1);
        this.set("allArraysOfNodesMatchingResults", []);
        this.set("allArraysOfNodesToHiglights", []);
        this.set("allArraysOfAdditionalMatchingResults", []);
        this.set("filteredAllArraysOfNodesMatchingResults", []);
        this.set("filteredAllArraysOfNodesToHiglights", []);
        this.set("filteredAllArraysOfAdditionalMatchingResults", []);
        this.set("allFilterProperties", null);
        this.set("filterOptions", null);
        this.set("filterFunction", null);
        this.set("searchRequestId", null);
        this.set("cachedAISuggestions", null);
        this.set("aiSuggestionsResultUrl", null);
        this.set("onShowSafeCut", false);
        this.set("improveSafetyWhenPossible", false);
        this.set("searchRequestId", null);
        this.set("isMediaAnalyzedForSilences", false);
        this.set("includeUntranscribed", false);

        
        // Initialize dismissed results tracking
        if(!this.get("dismissedResultIds")){
            this.set("dismissedResultIds", new Set());
        }
        
        // Search settings for context menu
        this.set("autoJumpToNext", true);
        this.set("previewWithOperation", false);
        this.set("previewWithoutOperation", false);
        
        this.listenTo(this._sequencer, "add", (this.onNodeAddedToSequencer).bind(this));
        this.listenTo(this._sequencer, "transcriptionCorrection", (this.onTranscriptionCorrection).bind(this));
        this.listenTo(this._sequencer, "remove", (this.onNodeRemovedFromSequencer).bind(this));
        this.listenTo(this._sequencer, "change:mediaAnalysisProgress", (this.onMediaAnalysisProgressChanged).bind(this));
        this.SEARCH_TYPE = SEARCH_TYPE;
        this.MEDIA_ANALYSIS_REASON = MEDIA_ANALYSIS_REASON;
        this.setSearchType(SEARCH_TYPE.TEXT_SEARCH);
        // Add search operation cancellation mechanism
        this._currentSearchOperationId = null;
        this._searchOperationCounter = 0;
        this._suggestionFeedbackQueue = [];
        this._suggestionFeedbackFlushTimeout = null;
        this._suggestionFeedbackInFlight = false;
        this._suggestionFeedbackRetryCount = 0;
        if(this._sequencer && this._sequencer.getHistoryManagement){
            this.listenTo(this._sequencer.getHistoryManagement(), "operationUndone", (this._onSequencerOperationUndone).bind(this));
        }
        
    },

    onNodeAddedToSequencer : function(){
        if(this.isSearchOn()){
            this._triggerSearchRefresh();
        }
    },

    isOnlyShowSafeCut : function(){
        return this.get("onShowSafeCut");
    },

    isMediaAnalyzedForSilences : function(){
        return this.get("isMediaAnalyzedForSilences");
    },

    setIsMediaAnalyzedForSilences : function(isMediaAnalyzedForSilences, reason){
        this.set("isMediaAnalyzedForSilences", isMediaAnalyzedForSilences);
        this.set("mediaAnalysisReason", reason || MEDIA_ANALYSIS_REASON.SILENCE);
    },

    getMediaAnalysisReason : function(){
        return this.get("mediaAnalysisReason");
    },


    getMediaAnalysisProgress : function(){
        return this._sequencer ? this._sequencer.getMediaAnalysisProgress() : 0;
    },

    setOnShowSafeCut : function(onShowSafeCut){
        this.set("onShowSafeCut", onShowSafeCut);
        // Ensure mutual exclusivity with improveSafetyWhenPossible
        if(onShowSafeCut && this.getImproveSafetyWhenPossible()){
            this.set("improveSafetyWhenPossible", false);
        }
        if(this.isSearchOn()){
            this._triggerSearchRefresh();
        }
    },

    getImproveSafetyWhenPossible : function(){
        return this.get("improveSafetyWhenPossible");
    },

    setImproveSafetyWhenPossible : function(improveSafetyWhenPossible){
        this.set("improveSafetyWhenPossible", improveSafetyWhenPossible);
        // Ensure mutual exclusivity with onShowSafeCut
        if(improveSafetyWhenPossible && this.isOnlyShowSafeCut()){
            this.set("onShowSafeCut", false);
        }
        if(this.isSearchOn()){
            this._triggerSearchRefresh();
        }
    },

    getIncludeUntranscribed : function(){
        return this.get("includeUntranscribed");
    },

    setIncludeUntranscribed : function(includeUntranscribed){
        this.set("includeUntranscribed", includeUntranscribed);
        if(this.isSearchOn()){
            this._triggerSearchRefresh();
        }
    },

    onTranscriptionCorrection: function(){
        if(this.isSearchOn()){
            this._triggerSearchRefresh();
        }
    },

    getSearchParams : function(){
        return this.get("searchParams");
    },

    _triggerSearchRefresh: function(){
        if(/*this.getSearchType() !==  SEARCH_TYPE.AI_EDIT_SUGGESTIONS &&*/ this.getSearchType() !==  SEARCH_TYPE.SEMANTIC_SEARCH /*&& this.getSearchType() !== SEARCH_TYPE.DISFLUENCY_SEARCH*/ ){
            if (this._pendingSearchWidgetUpdateHandlerId) {
                clearTimeout(this._pendingSearchWidgetUpdateHandlerId);
                this._pendingSearchWidgetUpdateHandlerId = null;
            }
            this._pendingSearchWidgetUpdateHandlerId = setTimeout((function(){
                this._pendingSearchWidgetUpdateHandlerId = null;
                this._applySearchDefault();
            }).bind(this), TIMEOUT_DELAY)
        }
    },

    _applySearchDefault: async function(useCachedSearchResults){
        const searchType = this.getSearchType();
            switch(searchType){
                case SEARCH_TYPE.DISFLUENCY_SEARCH:
                    await this.applyDisfluencySearch(this._disfluencySequencerNodeInfoArray, true, true, useCachedSearchResults)
                    break;
                case SEARCH_TYPE.TEXT_SEARCH:
                    await this.applyTextSearch(this.getSearchParams()?.searchKeyword, true, true, useCachedSearchResults);
                    break;
                case SEARCH_TYPE.SEMANTIC_SEARCH:
                    await this.applySemanticTextSearch(this.getSearchParams(), true, true, useCachedSearchResults);
                    break;
                case SEARCH_TYPE.AI_EDIT_SUGGESTIONS:
                    await this.applyAIEditSuggestions(this.getSearchParams(), true, true, useCachedSearchResults, this.getAiSuggestionsResultUrl(), null, this.getCachedAISuggestions());
                    break;
                case SEARCH_TYPE.FILLER_WORDS:
                    await this.applyFillerWordsSearch(true, true, useCachedSearchResults)
                    break;
                case SEARCH_TYPE.EDIT_BOUNDARIES:
                    await this.applyEditBoundariesSearch(true, true, useCachedSearchResults)
                    break;
                case SEARCH_TYPE.SILENCES:
                    await this.applySearchResultsForSilencesToTrim(this.getSearchParams().maxSilenceInMilliseconds,  true, true, useCachedSearchResults);
                    break;
                default:
                    await this.applyTextSearch(this.getSearchParams()?.searchKeyword, true, true, useCachedSearchResults);
                    break;                       
            }
    },

    onNodeRemovedFromSequencer : function(){
        if(this.isSearchOn()){
            this._triggerSearchRefresh();
        }
    },

    onMediaAnalysisProgressChanged : function(){
        // Trigger a change event so React components listening to this model will re-render
        this.trigger('change');
    },

    setSearchType : function(searchType){
        this.set("searchType",searchType);
        
        // Set default behavior for AI_EDIT_SUGGESTIONS search type based on feature flag
        if(searchType === SEARCH_TYPE.AI_EDIT_SUGGESTIONS && ENABLE_IMPROVE_SAFETY_BY_DEFAULT_FOR_AI_SUGGESTIONS){
            if(!this.isOnlyShowSafeCut() && !this.getImproveSafetyWhenPossible()){
                this.set("improveSafetyWhenPossible", true);
            }
        }
        
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'changeSearchType', 'Change search type', null,{searchType});
        }
    },

    getSearchType : function(searchType){
        return this.get("searchType");
    },


    getSequencer : function(){
        return this._sequencer;
    },

    clearSearch : function(){
        this.cancelOngoingSearchOperations();
        this._cancelSuggestionFeedbackFlushTimeout();
        this._flushSuggestionFeedbackQueue();
        this._clearSearch(true);
        this.setSearchType(SEARCH_TYPE.TEXT_SEARCH);
        this.setSearchOn(false);
        // Clear dismissed results when user explicitly clears search
        this.set("dismissedResultIds", new Set());
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'clearSearchWidget', 'Clear search widget');
        }
    },

    setSearchOn : function(searchOn){
        if(this._pendingSearchWidgetUpdateHandlerId){
            setTimeout(()=>{
                this.set("searchOn", searchOn);
            },TIMEOUT_DELAY)
        }else{
            this.set("searchOn", searchOn);
        }
    },

    setPlaybackOn : function(playbackOn){
        if(this._pendingSearchWidgetUpdateHandlerId){
            setTimeout(()=>{
                this.set("playbackOn", playbackOn);
            },TIMEOUT_DELAY)
        }else{
            this.set("playbackOn", playbackOn);
        }
    },


    isSearchOn : function(){
        return this.get("searchOn");
    },

    getPlaybackOn : function(){
        return this.get("playbackOn");
    },

    // Search settings getters and setters
    getAutoJumpToNext : function(){
        return this.get("autoJumpToNext");
    },

    setAutoJumpToNext : function(autoJumpToNext){
        this.set("autoJumpToNext", autoJumpToNext);
    },

    getPreviewWithOperation : function(){
        return this.get("previewWithOperation");
    },

    setPreviewWithOperation : function(previewWithOperation){
        this.set("previewWithOperation", previewWithOperation);
        // Ensure mutual exclusivity with previewWithoutOperation
        if(previewWithOperation && this.getPreviewWithoutOperation()){
            this.set("previewWithoutOperation", false);
        }
    },

    getPreviewWithoutOperation : function(){
        return this.get("previewWithoutOperation");
    },

    setPreviewWithoutOperation : function(previewWithoutOperation){
        this.set("previewWithoutOperation", previewWithoutOperation);
        // Ensure mutual exclusivity with previewWithOperation
        if(previewWithoutOperation && this.getPreviewWithOperation()){
            this.set("previewWithOperation", false);
        }
    },

    _clearSearch : function(){
        this.getAllArraysOfNodesToHiglights().forEach(function(arrayOfNodes){
            if(arrayOfNodes){
                arrayOfNodes.forEach(function(node){
                    node.setSearchHightlighted(false);
                })
            }
        })
        this.set("nodesInFocus",null);
        this.set("indexOfNodeInFocus", -1);
        this.set("allArraysOfNodesMatchingResults", []);
        this.set("allArraysOfNodesToHiglights", []);
        this.set("allArraysOfAdditionalMatchingResults", []);
        this.set("filteredAllArraysOfNodesMatchingResults", []);
        this.set("filteredAllArraysOfNodesToHiglights", []);
        this.set("filteredAllArraysOfAdditionalMatchingResults", []);
        this.set("allFilterProperties", null);
        this.set("filterOptions", null);
        this.set("filterFunction", null);
        this.set("searchRequestId", null);
        this.set("cachedAISuggestions", null);
        this.set("aiSuggestionsResultUrl", null);
        this.set("searchParams", null);
        this._cachedSearchResults = null;
        // Invalidate ongoing search operations when clearing
        //this._invalidateCurrentSearchOperations();
    },

    getCachedAISuggestions : function(){
        return this.get("cachedAISuggestions");
    },

    getAiSuggestionsResultUrl : function(){
        return this.get("aiSuggestionsResultUrl");
    },

    createDeletionSourceFromResult : function(resultInfo, appliedInBulk, additionalMatchingResult ){
        switch(this.getSearchType()){
            case SEARCH_TYPE.TEXT_SEARCH:
                return Utils.getInstance().createTextSearchDeletionSource(this.getSearchParams(), appliedInBulk);
            case SEARCH_TYPE.DISFLUENCY_SEARCH:
                return Utils.getInstance().createDisfluencySearchDeletionSource(appliedInBulk);
            case SEARCH_TYPE.FILLER_WORDS:
                return Utils.getInstance().createFillerWordSearchDeletionSource(appliedInBulk);
            case SEARCH_TYPE.SILENCES:
                return Utils.getInstance().createSilenceSearchDeletionSource(appliedInBulk);
            case SEARCH_TYPE.AI_EDIT_SUGGESTIONS:
                // For long silences detected within AI suggestions, use silence deletion source
                if(additionalMatchingResult && additionalMatchingResult.type === Utils.getInstance().getMediaTranscriptionAISearchQueryPresets().LONG_SILENCES){
                    return Utils.getInstance().createSilenceSearchDeletionSource(appliedInBulk);
                }
                return Utils.getInstance().createAIEditSuggestionDeletionSource(additionalMatchingResult.uid, additionalMatchingResult.reason, additionalMatchingResult.confidence, additionalMatchingResult.type, appliedInBulk,  additionalMatchingResult.recommendation, additionalMatchingResult.streamlinedSuggestionConfidence, additionalMatchingResult.isCustomType, additionalMatchingResult.customTypeLabel, this.getSearchRequestId());
            default: 
                return null;
        
        }
        return null;
    },

    _isValidDurableSearchRequestId : function(searchRequestId){
        return typeof searchRequestId === "string" && /^[a-f0-9]{24}$/i.test(searchRequestId);
    },

    _getCurrentProjectIdForFeedback : function(){
        if(!this._sequencer){
            return null;
        }
        if(this._sequencer.getProjectId && this._sequencer.getProjectId()){
            return this._sequencer.getProjectId();
        }
        if(this._sequencer.getLoadedProjectId && this._sequencer.getLoadedProjectId()){
            return this._sequencer.getLoadedProjectId();
        }
        return null;
    },

    _getCurrentTranscriptionIdForFeedback : function(){
        if(this._sequencer && this._sequencer.getFirstTranscriptionId){
            return this._sequencer.getFirstTranscriptionId();
        }
        return null;
    },

    _getNodeArrayFromRange : function(startNode, endNode){
        const nodeArray = [];
        let currentNode = startNode;
        let guard = 0;
        while(currentNode && guard < 10000){
            nodeArray.push(currentNode);
            if(currentNode === endNode){
                break;
            }
            currentNode = currentNode.getNext ? currentNode.getNext() : null;
            guard++;
        }
        return nodeArray;
    },

    _getSuggestionFeedbackNodeStats : function(nodeArray){
        let wordCount = 0;
        let secondsOfAudio = 0;
        if(nodeArray && nodeArray.length){
            nodeArray.forEach(function(node){
                if(node && node.getAudioSegment){
                    const audioSegment = node.getAudioSegment();
                    if(audioSegment){
                        const content = audioSegment.getContent ? audioSegment.getContent() : null;
                        if(content && content.trim){
                            const trimmedContent = content.trim();
                            if(trimmedContent){
                                wordCount = wordCount + trimmedContent.split(/\s+/).length;
                            }
                        }
                        const duration = audioSegment.getDuration ? audioSegment.getDuration() : null;
                        if(Number.isFinite(duration) && duration > 0){
                            secondsOfAudio = secondsOfAudio + (duration / 1000);
                        }
                    }
                }
            });
        }
        return {
            wordCount: wordCount || null,
            secondsOfAudio: secondsOfAudio || null
        };
    },

    _getSuggestionInfoFromDeletionSource : function(deletionSource){
        if(!deletionSource || !Utils.getInstance().isInstanceOfAISuggestionDeletionSource(deletionSource)){
            return null;
        }
        return {
            uid: deletionSource.getUid(),
            type: deletionSource.getSearchedElementCategory(),
            isCustomType: deletionSource.getIsCustomType(),
            confidence: deletionSource.getConfidence(),
            recommendation: deletionSource.getRecommendation(),
            streamlinedSuggestionConfidence: deletionSource.getStreamlinedSuggestionConfidence(),
            searchRequestId: deletionSource.getSearchRequestId ? deletionSource.getSearchRequestId() : null
        };
    },

    _getSuggestionInfoFromAdditionalMatchingResult : function(additionalMatchingResult){
        if(!additionalMatchingResult || !additionalMatchingResult.uid){
            return null;
        }
        return {
            uid: additionalMatchingResult.uid,
            type: additionalMatchingResult.type,
            isCustomType: additionalMatchingResult.isCustomType,
            confidence: additionalMatchingResult.confidence,
            recommendation: additionalMatchingResult.recommendation,
            streamlinedSuggestionConfidence: additionalMatchingResult.streamlinedSuggestionConfidence,
            searchRequestId: this.getSearchRequestId()
        };
    },

    _createSuggestionFeedbackEvent : function(action, suggestionInfo, nodeArray){
        if(!suggestionInfo || !suggestionInfo.uid){
            return null;
        }
        const searchRequestId = suggestionInfo.searchRequestId || this.getSearchRequestId();
        if(!this._isValidDurableSearchRequestId(searchRequestId)){
            return null;
        }
        const nodeStats = this._getSuggestionFeedbackNodeStats(nodeArray);
        return {
            searchRequestId,
            suggestionUid: suggestionInfo.uid,
            suggestionType: suggestionInfo.type,
            isCustomType: suggestionInfo.isCustomType === true,
            confidence: suggestionInfo.confidence,
            recommendation: suggestionInfo.recommendation,
            streamlinedSuggestionConfidence: suggestionInfo.streamlinedSuggestionConfidence,
            action,
            projectId: this._getCurrentProjectIdForFeedback(),
            transcriptionId: this._getCurrentTranscriptionIdForFeedback(),
            wordCount: nodeStats.wordCount,
            secondsOfAudio: nodeStats.secondsOfAudio,
            clientTimestamp: new Date().toISOString()
        };
    },

    _recordSuggestionFeedbackForAdditionalMatchingResult : function(action, additionalMatchingResult, nodeArray){
        if(this.getSearchType() !== SEARCH_TYPE.AI_EDIT_SUGGESTIONS){
            return;
        }
        const suggestionInfo = this._getSuggestionInfoFromAdditionalMatchingResult(additionalMatchingResult);
        const feedbackEvent = this._createSuggestionFeedbackEvent(action, suggestionInfo, nodeArray);
        this._queueSuggestionFeedbackEvent(feedbackEvent);
    },

    _recordSuggestionFeedbackForDeletionSource : function(action, deletionSource, nodeArray){
        const suggestionInfo = this._getSuggestionInfoFromDeletionSource(deletionSource);
        const feedbackEvent = this._createSuggestionFeedbackEvent(action, suggestionInfo, nodeArray);
        this._queueSuggestionFeedbackEvent(feedbackEvent);
    },

    recordAppliedSuggestionFeedbackForAdditionalMatchingResult : function(additionalMatchingResult, nodeArray){
        this._recordSuggestionFeedbackForAdditionalMatchingResult(SUGGESTION_FEEDBACK_ACTION.APPLIED, additionalMatchingResult, nodeArray);
    },

    recordAppliedSuggestionFeedbackForBulkDeletionResult : function(bulkDeletionResult){
        if(!bulkDeletionResult || !bulkDeletionResult.arrayOfDeleteNode || !bulkDeletionResult.arrayOfNodeArrayToReplace){
            return;
        }
        bulkDeletionResult.arrayOfDeleteNode.forEach((function(deleteNode, index){
            const nodeArray = bulkDeletionResult.arrayOfNodeArrayToReplace.length > index ? bulkDeletionResult.arrayOfNodeArrayToReplace[index] : null;
            if(deleteNode && deleteNode.getDeletionSource){
                this._recordSuggestionFeedbackForDeletionSource(SUGGESTION_FEEDBACK_ACTION.APPLIED, deleteNode.getDeletionSource(), nodeArray);
            }
        }).bind(this));
    },

    _queueSuggestionFeedbackEvent : function(feedbackEvent){
        if(!feedbackEvent){
            return;
        }
        this._suggestionFeedbackQueue.push(feedbackEvent);
        if(this._suggestionFeedbackQueue.length >= SUGGESTION_FEEDBACK_BATCH_SIZE){
            this._flushSuggestionFeedbackQueue();
        }else{
            this._scheduleSuggestionFeedbackFlush();
        }
    },

    _scheduleSuggestionFeedbackFlush : function(delayInMilliseconds){
        if(this._suggestionFeedbackFlushTimeout){
            return;
        }
        const flushDelay = Number.isFinite(delayInMilliseconds) ? delayInMilliseconds : SUGGESTION_FEEDBACK_FLUSH_DELAY_MS;
        this._suggestionFeedbackFlushTimeout = setTimeout((function(){
            this._suggestionFeedbackFlushTimeout = null;
            this._flushSuggestionFeedbackQueue();
        }).bind(this), flushDelay);
    },

    _cancelSuggestionFeedbackFlushTimeout : function(){
        if(this._suggestionFeedbackFlushTimeout){
            clearTimeout(this._suggestionFeedbackFlushTimeout);
            this._suggestionFeedbackFlushTimeout = null;
        }
    },

    _flushSuggestionFeedbackQueue : function(){
        if(this._suggestionFeedbackInFlight || !this._suggestionFeedbackQueue.length){
            return;
        }
        const batch = this._suggestionFeedbackQueue.splice(0, SUGGESTION_FEEDBACK_BATCH_SIZE);
        this._suggestionFeedbackInFlight = true;
        TrebbleClientAPIHelper.getInstance().recordSuggestionFeedback(batch).then((function(){
            this._suggestionFeedbackRetryCount = 0;
        }).bind(this), (function(error){
            if(this._suggestionFeedbackRetryCount < SUGGESTION_FEEDBACK_MAX_RETRY_COUNT){
                this._suggestionFeedbackRetryCount = this._suggestionFeedbackRetryCount + 1;
                this._suggestionFeedbackQueue = batch.concat(this._suggestionFeedbackQueue);
                this._scheduleSuggestionFeedbackFlush(SUGGESTION_FEEDBACK_FLUSH_DELAY_MS * this._suggestionFeedbackRetryCount);
            }else{
                this._suggestionFeedbackRetryCount = 0;
                console.warn("Suggestion feedback dropped after retries", error);
            }
        }).bind(this)).then((function(){
            this._suggestionFeedbackInFlight = false;
            if(this._suggestionFeedbackQueue.length){
                this._scheduleSuggestionFeedbackFlush();
            }
        }).bind(this));
    },

    _recordUndoneFeedbackFromDeleteNode : function(deleteNode, nodeArray){
        if(!deleteNode || !deleteNode.getDeletionSource){
            return;
        }
        this._recordSuggestionFeedbackForDeletionSource(SUGGESTION_FEEDBACK_ACTION.UNDONE, deleteNode.getDeletionSource(), nodeArray);
    },

    _onSequencerOperationUndone : function(operationLog){
        if(!operationLog){
            return;
        }
        const historyManagement = this._sequencer && this._sequencer.getHistoryManagement ? this._sequencer.getHistoryManagement() : null;
        if(!historyManagement){
            return;
        }
        if(historyManagement.isSequencerOperationCreateDeleteNodesLogInstance(operationLog)){
            this._recordUndoneFeedbackFromDeleteNode(operationLog.getDeleteNode(), operationLog.getNodeArrayToDelete ? operationLog.getNodeArrayToDelete() : null);
            return;
        }
        if(historyManagement.isSequencerOperationCreateDeleteNodesBulkLogInstance(operationLog)){
            const deleteNodes = operationLog.getArrayOfDeleteNode();
            const nodeArrays = operationLog.getArrayOfNodeArrayToDelete();
            if(deleteNodes && deleteNodes.length){
                deleteNodes.forEach((function(deleteNode, index){
                    const nodeArray = nodeArrays && nodeArrays.length > index ? nodeArrays[index] : null;
                    this._recordUndoneFeedbackFromDeleteNode(deleteNode, nodeArray);
                }).bind(this));
            }
        }
    },

    getCachedSearchResults : function(){
        return this._cachedSearchResults;
    },

    /*applySearch : function(searchParams, forceReset){
        if(forceReset || (this._searchParams !== searchParams? searchParams.trim().toLowerCase(): "")){
            this._clearSearch();
            this.setSearchOn(true);
            this._searchParams = searchParams? searchParams.trim().toLowerCase(): "";
            const nodesMatchingResults = [];
            if(this._searchParams){
                const node = this.getSequencer().getFirstNode();
                while(node){
                    if(Utils.getInstance().isWordSequencerNodeInstance(node) && this.getSequencer().isSequencerNodeVisible(node)){
                        const context = node.getAudioSegment().getContent();
                        if(context && context.search(new RegExp(this._searchParams, "i")) !== -1){
                            this._addNodeToArrayOfMatchingNodes(node);
                        }
                    }
                    node = node.getNext();
                }
                this.moveToNextFoundNode();
            }
        }
    },*/
    applyDisfluencySearch : async function(disfluencySequencerNodeInfoArray,forceReset, keepCurrentIndexInFocus, useCachedSearchResults){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.DISFLUENCY_SEARCH);
        const sequencerNodesWithDisfluenciesCidToDisfluencyInfo = {};
        this._disfluencySequencerNodeInfoArray =  disfluencySequencerNodeInfoArray;
        disfluencySequencerNodeInfoArray.map((disfluencyInfoArray)=>{
            disfluencyInfoArray.map((disfluencyInfo)=>{
                sequencerNodesWithDisfluenciesCidToDisfluencyInfo[disfluencyInfo.sequencerNode.getCid()] = disfluencyInfo;
            })
        })

        const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
            const results = {"isMatching": false, "shouldContinueMatching": false};
            if(Utils.getInstance().isWordSequencerNodeInstance(node) && (!onlyMatchVisible || sequencer.isSequencerNodeVisible(node))){
                const disfluencyInfo = sequencerNodesWithDisfluenciesCidToDisfluencyInfo[node.getCid()];
                if(disfluencyInfo){
                    results.isMatching = true;
                    results.shouldContinueMatching = true;//disfluencyInfo.isLinkedWithNextDisfluency;
                    context.isMatching = results.isMatching;
                    context.shouldContinueMatching = results.shouldContinueMatching;
                    context.isLinkedWithNextDisfluency = disfluencyInfo.isLinkedWithNextDisfluency;
                    return results;
                }else{
                    context.isMatching = results.isMatching;
                    context.shouldContinueMatching = results.shouldContinueMatching;
                    context.isLinkedWithNextDisfluency = false;
                    return results;
                }
            }else{
                if(context.isMatching && context.shouldContinueMatching && context.isLinkedWithNextDisfluency){
                    results.isMatching = true;
                    results.shouldContinueMatching = true;
                    context.isMatching = results.isMatching;
                    context.shouldContinueMatching = results.shouldContinueMatching;
                    context.isLinkedWithNextDisfluency = false;
                    return results;
                }else{ 
                    context.isMatching = results.isMatching;
                    context.shouldContinueMatching = results.shouldContinueMatching;
                    context.isLinkedWithNextDisfluency = false;
                    return results;
                }
                context.isMatching = results.isMatching;
                context.shouldContinueMatching = results.shouldContinueMatching;
                context.isLinkedWithNextDisfluency = false;
                return results;
            }
            return results;
        }

        const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
            return currentNodesToHighlights && currentNodesToHighlights.length > 0;
        }
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'turnOnDisfluencySearch', 'Turn on disfluency search');
        }
        
        // Track AI tool opened for Facebook
        if (window.FacebookEventTrackingHelper) {
            window.FacebookEventTrackingHelper.getInstance().trackAIToolOpened('Remove_Repeated_Words');
        }
        const result = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.DISFLUENCY_SEARCH, {id:null}), isMatchingSearchFunction,shouldSearchResultsBeingValidated, ()=>true, forceReset, keepCurrentIndexInFocus, useCachedSearchResults);
        
        if(this._isSearchOperationValid(operationId)){
            return result;
        }
        return null; // Operation was cancelled
    },

    applyTextSearch : async function(searchKeyword, forceReset, keepCurrentIndexInFocus, useCachedSearchResults){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.TEXT_SEARCH);
        const getWordsArrayFromSearchParams = function(search){
            if(!search || !search.trim()){
                return [];
            }
            // Split the sentence into words using spaces as a delimiter
            var words = search.trim().split(/\s+/);

            // Check if the last word has trailing spaces and convert to lowercase
            if (search.endsWith(" ")) {
                words[words.length - 1] = words[words.length - 1].toLowerCase() + " ";
            } else {
                // Convert all words to lowercase
                words = words.map(function (word) {
                return word.toLowerCase();
                });
            }

            return words;
        }

        const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
            const results = {"isMatching": false, "shouldContinueMatching": false};
            if(searchParams?.searchKeyword && typeof searchParams?.searchKeyword === "string" && searchParams?.searchKeyword.trim().toLowerCase()){
                const arrayOfWords = getWordsArrayFromSearchParams(searchParams?.searchKeyword);
                if(arrayOfWords.length > currentNodesMatchingResults.length){
                    const wordToMatchAgainst = arrayOfWords[currentNodesMatchingResults.length];
                    if(Utils.getInstance().isWordSequencerNodeInstance(node) && (!onlyMatchVisible || sequencer.isSequencerNodeVisible(node))){
                        const content = node.getAudioSegment().getContent();
                        if(currentNodesMatchingResults.length + 1 === arrayOfWords.length){
                            //Last word
                            results.isMatching = content && content.search(new RegExp(Utils.getInstance().escapeRegExp(wordToMatchAgainst.trim())+(wordToMatchAgainst.endsWith(" ")?"\\b":""), "i")) !== -1;
                            results.shouldContinueMatching = results.isMatching;
                            return results;
                        }else{
                            results.isMatching = content.trim().toLowerCase() === wordToMatchAgainst.trim().toLowerCase();
                            results.shouldContinueMatching = results.isMatching;
                            return results;
                        }
                    }else{
                        results.shouldContinueMatching = currentNodesMatchingResults.length > 0?true: false;
                        return results;
                    }
                }else{
                    return results;
                }
            }
            return results;
        }

        const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
            const arrayOfWords = getWordsArrayFromSearchParams(searchParams?.searchKeyword);
            return currentNodesMatchingResults && arrayOfWords &&  currentNodesMatchingResults.length === arrayOfWords.length;
        }

        const isSearchParamsChanged = function(currentSearchParams, newSearchParams){
            if((currentSearchParams && !newSearchParams)|| (!currentSearchParams && newSearchParams)){
                return true;
            }

            const currentSearchKeyword = typeof currentSearchParams?.searchKeyword === "string" ? currentSearchParams.searchKeyword.toLowerCase() : "";
            const newSearchKeyword = typeof newSearchParams?.searchKeyword === "string" ? newSearchParams.searchKeyword.toLowerCase() : "";
            if(currentSearchParams?.searchType !== newSearchParams?.searchType){
                return true;
            }

            return currentSearchKeyword !== newSearchKeyword;
        }

        const result = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.TEXT_SEARCH, {searchKeyword}), isMatchingSearchFunction,shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults);
        
        if(this._isSearchOperationValid(operationId)){
            return result;
        }
        return null; // Operation was cancelled
    },

    applySemanticTextSearch : async function(searchParams, forceReset, keepCurrentIndexInFocus, useCachedSearchResults){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.SEMANTIC_SEARCH);
        if(searchParams){
            const {sequencerNodeIdsToGroup, pendingRequest, requestId} = await this.getSequencer().findSemanticTextSearchResult(searchParams, forceReset);
            if(pendingRequest){
                this.getSequencer().closeSearchPanel();
                return
            }
            if(!this._isSearchOperationValid(operationId)){
                return null; // Operation was cancelled
            }
            const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
                const results = {"isMatching": false, "shouldContinueMatching": false};
                const groupInfo = sequencerNodeIdsToGroup? sequencerNodeIdsToGroup[node.cid]: sequencerNodeIdsToGroup;
                if(groupInfo){
                    results.isMatching = !!groupInfo;
                    // Additions set shouldContinueMatching=false so they don't get absorbed into adjacent deletion groups
                    results.shouldContinueMatching = groupInfo.shouldContinueMatching !== false;
                    if(results.isMatching){
                        results.additionalMatchingResults = {reason: groupInfo?.group?.reason, type: groupInfo?.type, isCustomType: groupInfo?.isCustomType, customTypeLabel: groupInfo?.customTypeLabel, confidence: groupInfo?.confidence, uid:groupInfo?.uid , recommendation: groupInfo?.recommendation, streamlinedSuggestionConfidence: groupInfo?.streamlinedSuggestionConfidence, isAddition: groupInfo?.isAddition || false, additionData: groupInfo?.additionData || null, positionLabel: groupInfo?.positionLabel || null};
                    }
                    return results;
                }else{
                    if(currentNodesMatchingResults.length > 0){
                        const lastGroupInfo = sequencerNodeIdsToGroup? sequencerNodeIdsToGroup[currentNodesMatchingResults[currentNodesMatchingResults.length-1].cid]: sequencerNodeIdsToGroup;
                        if(currentNodesMatchingResults.length < lastGroupInfo?.group?.sequencerNodes.length){
                            results.isMatching = true;
                            results.shouldContinueMatching = true;
                            return results;
                        }
                    }
                }
                return results;
            }
        

            const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
                return currentNodesMatchingResults && currentNodesMatchingResults.length > 0;
            }

            const isSearchParamsChanged = function(currentSearchParams, newSearchParams){
                return true;                                    
            }

            const result = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.SEMANTIC_SEARCH, { ...searchParams, id: requestId}), isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults);
            
            if(this._isSearchOperationValid(operationId)){
                return result;
            }
            return null; // Operation was cancelled
        }
    },

    _detectSilencesAsAISuggestions : async function(maxSilenceInMilliseconds = LONG_SILENCE_THRESHOLD_MS, existingNodeIdsToGroup = {}){
        // Ensure media is analyzed for silences before detecting them
        await this._analyzeMediaForSilencesIfNeeded(MEDIA_ANALYSIS_REASON.SILENCE);
        
        const doubleVerifyWithAudioClassification = true;
        const {isMatchingSearchFunction: originalSilenceMatchingFunction} = this._getSearchResultsForSilencesToTrimParams(maxSilenceInMilliseconds, doubleVerifyWithAudioClassification);
        
        const silenceNodeIdsToGroup = {};
        let silenceUidCounter = 0;
        
        // Create a custom matching function that includes additionalMatchingResults
        const silenceMatchingFunctionWithMetadata = function(node, currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context) {
            const results = originalSilenceMatchingFunction(node, currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context);
            
            // If this is a matching silence node, add the AI suggestion metadata
            if (results.isMatching) {
                const uid = `silence_${Date.now()}_${silenceUidCounter++}`;
                results.additionalMatchingResults = {
                    reason: null,
                    type: Utils.getInstance().getMediaTranscriptionAISearchQueryPresets().LONG_SILENCES,
                    isCustomType: true,
                    customTypeLabel: window.getI18n(ti18n, "AI_SEARCH_QUERY_PRESET_LONG_SILENCES"),
                    confidence: Utils.getInstance().getStreamlineSuggestionConfidenceLevels().HIGH,
                    streamlinedSuggestionConfidence: Utils.getInstance().getStreamlineSuggestionConfidenceLevels().HIGH,
                    recommendation: null,
                    uid: uid
                };
            }
            
            return results;
        };
        
        const searchParams = { id: null }; // Provide searchParams with id property
        const silenceResults = this.getSearchResultsGeneric(searchParams, silenceMatchingFunctionWithMetadata, (nodes) => nodes && nodes.length > 0, () => true, false, null, null);
        
        // Convert silence results to AI suggestion format
        silenceResults.allArraysOfNodesMatchingResults.forEach((silenceNodes, index) => {
            if(silenceNodes && silenceNodes.length > 0){
                const additionalResult = silenceResults.allArraysOfAdditionalMatchingResults[index];
                const uid = additionalResult ? additionalResult.uid : `silence_${Date.now()}_${silenceUidCounter++}`;
                const group = {
                    sequencerNodes: silenceNodes,
                    reason: null
                };
                
                // Add each node in the silence group to the mapping
                // Only add nodes that are not already in AI suggestions (AI suggestions have priority)
                silenceNodes.forEach((node) => {
                    if (!existingNodeIdsToGroup[node.cid]) {
                        silenceNodeIdsToGroup[node.cid] = {
                            group: group,
                            type: Utils.getInstance().getMediaTranscriptionAISearchQueryPresets().LONG_SILENCES,
                            confidence: Utils.getInstance().getStreamlineSuggestionConfidenceLevels().HIGH,
                            streamlinedSuggestionConfidence: Utils.getInstance().getStreamlineSuggestionConfidenceLevels().HIGH,
                            recommendation: null,
                            uid: uid
                        };
                    }
                });
            }
        });
        
        return silenceNodeIdsToGroup;
    },

    applyAIEditSuggestions : async function(searchParams, forceReset, keepCurrentIndexInFocus, useCachedSearchResults, aiSuggestionResultUrl, requestId, cachedAiSuggestions){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.AI_EDIT_SUGGESTIONS);
        
        // Track AI tool opened
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'openAIEditSuggestions', 'DeepCut AI suggestions opened');
        }
        
        // Track AI tool opened for Facebook
        if (window.FacebookEventTrackingHelper) {
            window.FacebookEventTrackingHelper.getInstance().trackAIToolOpened('DeepCut_Analysis');
        }
        if(searchParams){
            const {sequencerNodeIdsToGroup, pendingRequest, requestId, aiSuggestions, isEditLikeMeMode, referenceProjectId, aiSuggestionsResultUrl} = await this.getSequencer().findSemanticTextSearchResult(searchParams, forceReset, aiSuggestionResultUrl, requestId,cachedAiSuggestions);
            if(pendingRequest){
                this.getSequencer().closeSearchPanel();
                return null;
            }
            
            if(!this._isSearchOperationValid(operationId)){
                return null; // Operation was cancelled
            }
            
            // Conditionally detect long silences and merge with AI suggestions
            let mergedNodeIdsToGroup = sequencerNodeIdsToGroup;
            if (ENABLE_LONG_SILENCES_IN_AI_SUGGESTIONS) {
                this.setSearchOn(true);
                const silenceNodeIdsToGroup = await this._detectSilencesAsAISuggestions(LONG_SILENCE_THRESHOLD_MS, sequencerNodeIdsToGroup);
                mergedNodeIdsToGroup = { ...silenceNodeIdsToGroup, ...sequencerNodeIdsToGroup };
            }
            const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
                const results = {"isMatching": false, "shouldContinueMatching": false};
                const groupInfo = mergedNodeIdsToGroup? mergedNodeIdsToGroup[node.cid]: mergedNodeIdsToGroup;
                if(groupInfo){
                    results.isMatching = !!groupInfo;
                    results.shouldContinueMatching = true;
                    if(results.isMatching){
                        results.additionalMatchingResults = {reason: groupInfo?.group?.reason, recommendation: groupInfo?.recommendation, type: groupInfo?.type, isCustomType: groupInfo?.isCustomType, customTypeLabel: groupInfo?.customTypeLabel, confidence: groupInfo?.confidence, uid:groupInfo?.uid ,  streamlinedSuggestionConfidence: groupInfo?.streamlinedSuggestionConfidence, isAddition: groupInfo?.isAddition || false, additionData: groupInfo?.additionData || null};
                    }
                    return results;
                }else{
                    if(currentNodesMatchingResults.length > 0){
                        const lastGroupInfo = mergedNodeIdsToGroup? mergedNodeIdsToGroup[currentNodesMatchingResults[currentNodesMatchingResults.length-1].cid]: mergedNodeIdsToGroup;
                        if(currentNodesMatchingResults.length < lastGroupInfo?.group?.sequencerNodes.length){
                            results.isMatching = true;
                            results.shouldContinueMatching = true;
                            return results;
                        }
                    }
                }
                return results;
            }
        

            const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
                return currentNodesMatchingResults && currentNodesMatchingResults.length > 0;
            }

            const isSearchParamsChanged = function(currentSearchParams, newSearchParams){
                return true;                                    
            }
            const propertyFilterInfo = [{key:"type",label: window.getI18n(ti18n,"TYPE")},/* {key:"confidence", label: window.getI18n(ti18n,"CONFIDENCE")}, {key:"recommendation", label: window.getI18n(ti18n,"RECOMMENDATION"), }, */{key:"streamlinedSuggestionConfidence", label: window.getI18n(ti18n,"CONFIDENCE")}];
            const mapOfOptionsToExclude = {/*"confidence":
                [Utils.getInstance().getMediaTranscriptionAISearchResultConfidenceLevels().MEDIUM, Utils.getInstance().getMediaTranscriptionAISearchResultConfidenceLevels().LOW],
                "recommendation": [ Utils.getInstance().getMediaTranscriptionAISearchResultValidationLevels().ACCEPT, Utils.getInstance().getMediaTranscriptionAISearchResultValidationLevels().REJECT, Utils.getInstance().getMediaTranscriptionAISearchResultValidationLevels().CONSIDER_REVISING]*/
                "streamlinedSuggestionConfidence": [Utils.getInstance().getStreamlineSuggestionConfidenceLevels().MEDIUM, Utils.getInstance().getStreamlineSuggestionConfidenceLevels().LOW]
            };
            const functionToGetAllFilterProps  = this.getAdditionalFilterPropertiesFunction(propertyFilterInfo, mapOfOptionsToExclude, this.getFilterOptions());
            const filterFunction = this.getContentFilterFunction(functionToGetAllFilterProps);
            const isEditLikeMeSearch = isEditLikeMeMode === true || isEditLikeMeMode === "true" || searchParams?.isEditLikeMeMode === true || searchParams?.isEditLikeMeMode === "true";
            const aiEditSearchParams = {
                ...searchParams,
                id: requestId,
                isEditLikeMeMode: isEditLikeMeSearch
            };
            if (referenceProjectId || searchParams?.referenceProjectId) {
                aiEditSearchParams.referenceProjectId = referenceProjectId || searchParams.referenceProjectId;
            }
            const results = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.AI_EDIT_SUGGESTIONS, aiEditSearchParams), isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults, functionToGetAllFilterProps, filterFunction);
            if(this._isSearchOperationValid(operationId)){
                this.set("cachedAISuggestions", aiSuggestions);
                this.set("aiSuggestionsResultUrl", aiSuggestionsResultUrl);
                return results;
            }
            return null; // Operation was cancelled
        }
    },

    applyFillerWordsSearch : async function(forceReset, keepCurrentIndexInFocus, useCachedSearchResults){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.FILLER_WORDS);
        
        // Track AI tool opened
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'openFillerWordsSearch', 'Filler words search opened');
        }
        
        // Track AI tool opened for Facebook
        if (window.FacebookEventTrackingHelper) {
            window.FacebookEventTrackingHelper.getInstance().trackAIToolOpened('Remove_Filler_Words');
        }
        const {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged } = this._getFilleWordSearchParams();
        const createFilterPropertiesFunction =  this.getContentFilterPropertiesFunction(this.getFillerWordTextContentFromFArrayOfNodesFunction(), this.getFilterOptions());
        const filterFunction = this.getContentFilterFunction(createFilterPropertiesFunction);
        const result = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.FILLER_WORDS, {}), isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults, createFilterPropertiesFunction, filterFunction);

        if(this._isSearchOperationValid(operationId)){
            return result;
        }
        return null; // Operation was cancelled
    },

    _getFilleWordSearchParams : function(){
        const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
            const results = {"isMatching": false, "shouldContinueMatching": false};
            if(Utils.getInstance().isWordSequencerNodeInstance(node) && (!onlyMatchVisible || sequencer.isSequencerNodeVisible(node))){
                const content = node.getAudioSegment().getContent();
                if(content && content.trim().toLowerCase()){
                    const regexToTestFillerWords =  new RegExp(`^(${sequencer.getFillerWords().join("|")})+[.,]*$`,"i");
                    results.isMatching = regexToTestFillerWords.test(content.trim().toLowerCase());
                    results.shouldContinueMatching = results.isMatching;
                }
                return results;
            }else{
                results.shouldContinueMatching = false;//currentNodesMatchingResults.length > 0?true: false;
                return results;
            }
            return results;
        }

        const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
            return currentNodesMatchingResults && currentNodesMatchingResults.length > 0;
        }

        const isSearchParamsChanged = function(currentSearchParams, newSearchParams){
            return true;
        }

        return {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged };
    },

    applyEditBoundariesSearch : async function(forceReset, keepCurrentIndexInFocus, useCachedSearchResults){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.EDIT_BOUNDARIES);
        const {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged } = this._getEditBoundariesSearchParams();
        const result = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.EDIT_BOUNDARIES,{}), isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults);
        
        if(this._isSearchOperationValid(operationId)){
            return result;
        }
        return null; // Operation was cancelled
    },


    _getEditBoundariesSearchParams : function(){
        const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
            const results = {"isMatching": false, "shouldContinueMatching": false};
            if(!node.isThereContinuityOnLeft()){
                results.isMatching = true;
                results.shouldContinueMatching = true;
                return results;
            }else{
                results.shouldContinueMatching = false;//currentNodesMatchingResults.length > 0?true: false;
                return results;
            }
            return results;
        }

        const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
            return currentNodesMatchingResults && currentNodesMatchingResults.length > 0;
        }

        const isSearchParamsChanged = function(currentSearchParams, newSearchParams){
            return true;
        }

        return {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged };
    },

    getSearhResultsForFillerWords : function(){
        const {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged } = this._getFilleWordSearchParams();
        return this.getSearchResultsGeneric(null, isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, false, null, null);
    },

    _getSearchResultsForSilencesToTrimParams : function(maxSilenceInMilliseconds, doubleVerifyWithAudioClassification){
        const isMatchingSearchFunction = function(node,currentNodesMatchingResults, searchParams, sequencer, onlyMatchVisible, context){
            const results = {"isMatching": false, "shouldContinueMatching": false};
            if(Utils.getInstance().isPauseSequencerNodeInstance(node) && (!onlyMatchVisible || sequencer.isSequencerNodeVisible(node)) && (!doubleVerifyWithAudioClassification || /*SequencerNodeUtils.getInstance().doesSequencerNodeOnlyContainsBackgroundNoise(node)*/ !SequencerNodeUtils.getInstance().doesSequenerNodeContainsVoiceActivity(node, false, VoiceActivityDetectionManager.VAD_CONFIGS.BALANCED))){
                const duration = node.getAudioSegment().getDuration();
                if(!context.lastCountedDuration){
                    context.lastCountedDuration = 0;
                }
                
                context.lastCountedDuration = context.lastCountedDuration + duration;
                const countedDuration = context.lastCountedDuration;
                if(countedDuration > maxSilenceInMilliseconds){
                    results.isMatching = true;
                    results.shouldContinueMatching = true;
                }
                return results;
            }else{
                if(context.lastCountedDuration > 0){
                    if(Utils.getInstance().isPauseSequencerNodeInstance(node) 
                        || Utils.getInstance().isStartMusicWrapSequencerNodeInstance(node)
                        || Utils.getInstance().isEndMusicWrapSequencerNodeInstance(node)
                        || Utils.getInstance().isAudioSequencerNodeInstance(node)
                        || Utils.getInstance().isVideoSequencerNodeInstance(node)
                        || Utils.getInstance().isAudioEventSequencerNodeInstance(node)
                        || Utils.getInstance().isWordSequencerNodeInstance(node)
                        || Utils.getInstance().isUnsupportedAudioSequencerNodeInstance(node)
                         || (node.getAudioSegment() && node.getAudioSegment().getDuration() > 0)){
                        context.lastCountedDuration =  0;
                    }else{
                        // keep the lastCountedDuration the same
                        if(context.lastCountedDuration > maxSilenceInMilliseconds){
                            results.isMatching = true;
                            results.shouldContinueMatching = true;
                        }
                    }
                    return results;
                }else{
                    context.lastCountedDuration =  0;
                    return results;
                }
                
            }
            return results;
        }

        const shouldSearchResultsBeingValidated = function(currentNodesMatchingResults, currentNodesToHighlights, searchParams, sequencer, context){
            return currentNodesMatchingResults && currentNodesMatchingResults.length > 0;
        }

        const isSearchParamsChanged = function(currentSearchParams, newSearchParams){
            return true;
        }
        return {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged };

    },

    _createSearchParams: function(searchType, searchParams){  
        return {searchType, ...searchParams};
    },


    applySearchResultsForSilencesToTrim : async function(maxSilenceInMilliseconds, forceReset, keepCurrentIndexInFocus, useCachedSearchResults){
        const operationId = this._startNewSearchOperation();
        this.setSearchType(SEARCH_TYPE.SILENCES);
        
        // Track AI tool opened
        if(window.trebbleAnalyticsHelper){
            window.trebbleAnalyticsHelper.trackEvent("sequencer", 'openSilenceSearch', 'Silence search opened');
        }
        
        // Track AI tool opened for Facebook
        if (window.FacebookEventTrackingHelper) {
            window.FacebookEventTrackingHelper.getInstance().trackAIToolOpened('Remove_Silences');
        }
        if(!this._isSearchOperationValid(operationId)){
            return null;
        }
        const doubleVerifyWithAudioClassification = !this.getIncludeUntranscribed();
        const {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged } = this._getSearchResultsForSilencesToTrimParams(maxSilenceInMilliseconds, doubleVerifyWithAudioClassification);
        const result = await this.applySearchGeneric(operationId, this._createSearchParams(SEARCH_TYPE.SILENCES, {maxSilenceInMilliseconds: maxSilenceInMilliseconds}), isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults);
        
        if(this._isSearchOperationValid(operationId)){
            return result;
        }
        return null; // Operation was cancelled
    },

    getSearchResultsForSilencesToTrim : function(maxSilenceInMilliseconds){
        const doubleVerifyWithAudioClassification = !this.getIncludeUntranscribed();
        const {isMatchingSearchFunction,shouldSearchResultsBeingValidated,isSearchParamsChanged } = this._getSearchResultsForSilencesToTrimParams(maxSilenceInMilliseconds, doubleVerifyWithAudioClassification);
        return this.getSearchResultsGeneric(null, isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, false, null, null);
    },


    getSearchResultsGeneric : function(searchParams, isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, onlyMatchVisible, firstNode, lastNode, createFilterPropertiesFunction, filterFunction){
        const allArraysOfNodesMatchingResults = [];
        const allArraysOfNodesToHiglights = [];
        let currentNodesMatchingResults = [];
        let allArraysOfAdditionalMatchingResults = [];
        let currentAdditionalMatchingResults = [];
        let currentNodesToHighlights = [];
        const context = {};
        let results = {};
        
        let node = firstNode? firstNode: this.getSequencer().getFirstNode();
        while(node){
            results = isMatchingSearchFunction(node,currentNodesMatchingResults, searchParams, this.getSequencer(),onlyMatchVisible,  context);
            if(results.isMatching){
                currentNodesMatchingResults.push(node);
                if(results.additionalMatchingResults){
                    currentAdditionalMatchingResults.push(results.additionalMatchingResults);
                }
            }
            if(results.shouldContinueMatching){
                currentNodesToHighlights.push(node);
            }
            if(!results.isMatching && !results.shouldContinueMatching){
                if(currentNodesMatchingResults.length > 0){
                    if(shouldSearchResultsBeingValidated(currentNodesMatchingResults, currentNodesToHighlights, searchParams, this.getSequencer(), context)){
                        // Only add if not dismissed
                        if(!this._isResultDismissed(currentNodesMatchingResults)){
                            allArraysOfNodesMatchingResults.push(currentNodesMatchingResults);
                            allArraysOfNodesToHiglights.push(currentNodesToHighlights);
                            if(currentAdditionalMatchingResults.length > 0){
                                allArraysOfAdditionalMatchingResults.push(currentAdditionalMatchingResults[currentAdditionalMatchingResults.length - 1]);
                            }
                        }
                    }	
                }
                currentNodesMatchingResults = [];
                currentNodesToHighlights = [];
            }
            if(lastNode && node === lastNode){
                node = null;
            }else{
                node = node.getNext();
            }
        }

        if(currentNodesMatchingResults.length > 0){
            if(shouldSearchResultsBeingValidated(currentNodesMatchingResults, currentNodesToHighlights, searchParams, this.getSequencer(), context)){
                // Only add if not dismissed
                if(!this._isResultDismissed(currentNodesMatchingResults)){
                    allArraysOfNodesMatchingResults.push(currentNodesMatchingResults);
                    allArraysOfNodesToHiglights.push(currentNodesToHighlights);
                    if(currentAdditionalMatchingResults.length > 0){
                        allArraysOfAdditionalMatchingResults.push(currentAdditionalMatchingResults[currentAdditionalMatchingResults.length - 1]);
                    }
                }
            }	
        }
        
        const {allfilterProperties, filterOptions} = createFilterPropertiesFunction? createFilterPropertiesFunction(allArraysOfNodesMatchingResults,allArraysOfNodesToHiglights, allArraysOfAdditionalMatchingResults ): {};
        return {"allArraysOfNodesMatchingResults": allArraysOfNodesMatchingResults,"allArraysOfNodesToHiglights": allArraysOfNodesToHiglights , allArraysOfAdditionalMatchingResults, id: searchParams.id, allfilterProperties, filterOptions, filterFunction};
        
    },

    getFillerWordTextContentFromFArrayOfNodesFunction : function(){
        const postProcessingFunction = (text)=>{
            // Convert the text to lowercase
            let cleanedElement = text.toLowerCase();
    
            // Remove punctuation and "..."
            cleanedElement = cleanedElement.replace(/[^\w\s]|\.{3,}/g, '').trim();
            return cleanedElement;
        }
        return this.getTextContentFromArrayOfNodesFunction(postProcessingFunction);
    },  

    getTextContentFromArrayOfNodesFunction : function(postProcessingFunction){
        return ( arrayOfNodesMatchingResults, arrayOfNodesToHiglights, arrayOfAdditionalMatchingResults)=>{
            if( arrayOfNodesToHiglights && arrayOfNodesToHiglights.length > 0){
                return arrayOfNodesToHiglights.reduce((accumulatedKey, nodeToHighlight)=>{
                    if(Utils.getInstance().isWordSequencerNodeInstance(nodeToHighlight)){
                        const preProcessCurrentContent = nodeToHighlight.getContent();
                        const currentContent = postProcessingFunction? postProcessingFunction(preProcessCurrentContent): preProcessCurrentContent;
                        if(currentContent){
                            if(!accumulatedKey){
                                return currentContent;
                            }else{
                                return accumulatedKey  + " "+currentContent;
                            }
                        }
                    }
                    return accumulatedKey;
                }, "")
            }
            return null;
        }
    },

    getContentFilterPropertiesFunction : function(functionToGetPropertyKey, presetFilterOptions){
        return (allArraysOfNodesMatchingResults,allArraysOfNodesToHiglights, allArraysOfAdditionalMatchingResults)=>{
            const optionsKeys = [];
            
            allArraysOfNodesToHiglights.map((arrayOfNodesToHiglights, i)=>{
                const propertyKey =  functionToGetPropertyKey(allArraysOfNodesMatchingResults[i], arrayOfNodesToHiglights, allArraysOfAdditionalMatchingResults?allArraysOfAdditionalMatchingResults[i]: null);
                if(!optionsKeys.includes(propertyKey)){
                    optionsKeys.push(propertyKey);
                }
            })
            
            const allfilterProperties =  [{key:"text", label: window.getI18n(ti18n, "CONTENT"),"functionToGetPropertyKey": functionToGetPropertyKey, options: optionsKeys.map((propertyKey)=>{
                if(!propertyKey){
                   return {key:propertyKey, label: `(${window.getI18n(ti18n,"BLANK")})`}
                }
                return {key:propertyKey, label: propertyKey}
            })}]
            let filterOptions = presetFilterOptions;
            if(!filterOptions){
                filterOptions = {};
                allfilterProperties.map(({key, label, functionToGetPropertyKey, options})=>{
                    let optionsSelected =  filterOptions[key];
                    if(!optionsSelected){
                        optionsSelected = [];
                        filterOptions[key] = optionsSelected;
                    }
                    filterOptions[key]  = options.map((optionInfo)=>{
                        return optionInfo.key;
                    });
                })
            }

            return {allfilterProperties, filterOptions}

        }
    },

    getContentFilterFunction : function(functionToGetAllFilterProps){
        return (filterOptions, allArraysOfNodesMatchingResults,allArraysOfNodesToHiglights, allArraysOfAdditionalMatchingResults)=>{
            const filteredAllArraysOfNodesMatchingResults = [];
            const filteredAllArraysOfNodesToHiglights = [];
            const filteredAllArraysOfAdditionalMatchingResults = allArraysOfAdditionalMatchingResults? []: null;
            const {allfilterProperties} = functionToGetAllFilterProps(allArraysOfNodesMatchingResults,allArraysOfNodesToHiglights, allArraysOfAdditionalMatchingResults);
            for(let i = 0; i < allArraysOfNodesMatchingResults.length; i++){
                const arrayOfNodesMatchingResults = allArraysOfNodesMatchingResults[i];
                const arrayOfNodesToHiglights = allArraysOfNodesToHiglights[i];
                const arrayOfAdditionalMatchingResults = allArraysOfAdditionalMatchingResults? allArraysOfAdditionalMatchingResults[i]: null;
                let validResult = true;
                const isAdditionResult = arrayOfAdditionalMatchingResults && arrayOfAdditionalMatchingResults.isAddition === true;
                for(let u = 0; u < allfilterProperties.length; u++){
                    let filterPropInfo = allfilterProperties[u];
                    // Addition suggestions always show regardless of confidence level — they have
                    // their own acceptance threshold set by the Lambda evaluation step, so applying
                    // the deletion-oriented confidence filter would incorrectly hide valid additions.
                    if(isAdditionResult && filterPropInfo.key === "streamlinedSuggestionConfidence"){
                        continue;
                    }
                    if(Object.keys(filterOptions).includes(filterPropInfo.key)){
                        const value = filterPropInfo.functionToGetPropertyKey(arrayOfNodesMatchingResults, arrayOfNodesToHiglights, arrayOfAdditionalMatchingResults);
                        const acceptedPropertyValues = filterOptions[filterPropInfo.key];
                        if (!acceptedPropertyValues.some(prop => value.includes(prop))) {
                            validResult = false;
                            break;
                        }
                    }
                }
                if(validResult){
                    filteredAllArraysOfNodesMatchingResults.push(arrayOfNodesMatchingResults);
                    filteredAllArraysOfNodesToHiglights.push(arrayOfNodesToHiglights);
                    if(arrayOfAdditionalMatchingResults && filteredAllArraysOfAdditionalMatchingResults){
                        filteredAllArraysOfAdditionalMatchingResults.push(arrayOfAdditionalMatchingResults);
                    }
                }

            }
            return {filteredAllArraysOfNodesMatchingResults, filteredAllArraysOfNodesToHiglights, filteredAllArraysOfAdditionalMatchingResults};
        }
    },

    createGetOptionLabelForAdditonalFilterOptionsFunction: function(){
        return function(propKey, optionKey, arrayOfAdditionalMatchingResults){
            if(propKey === "type"){
                const value = window.getI18n(ti18n, "AI_SEARCH_QUERY_PRESET_"+optionKey.toUpperCase()) || window.getI18n(ti18n, "AI_SEARCH_QUERY_PRESET_"+optionKey);
                return value ? value : arrayOfAdditionalMatchingResults.typeLabel || arrayOfAdditionalMatchingResults.customTypeLabel || optionKey;
            }
            if(propKey === "confidence"){
                const value = window.getI18n(ti18n, "AI_SEARCH_RESULT_CONFIDENCE_LEVEL_"+ Utils.getInstance().getAISuggestionConfidenceLevelEnumKeyFromValue(optionKey));
                return value? value: optionKey;
            }
            if(propKey === "recommendation"){
                const value = window.getI18n(ti18n, "AI_SEARCH_RESULT_RECOMMENDATION_"+Utils.getInstance().getAISuggestionRecommendationTypesEnumKeyFromValue(optionKey));
                return value? value: optionKey;
            }
            if(propKey === "streamlinedSuggestionConfidence"){
                const value = window.getI18n(ti18n, "AI_SEARCH_RESULT_STREAMLINED_RECOMMENDATION_"+Utils.getInstance().getAISuggestionStreamlinedConfidenceLevelEnumKeyFromValue(optionKey));
                return value? value: optionKey;
            }
            return optionKey;
        }
    },

    getAdditionalFilterPropertiesFunction : function(arrayOfProperties, mapOfOptionsToExclude , presetFilterOptions){
        const getOptionLabelFunction = this.createGetOptionLabelForAdditonalFilterOptionsFunction();
        return (allArraysOfNodesMatchingResults,allArraysOfNodesToHiglights, allArraysOfAdditionalMatchingResults)=>{
            const keyToOptions = {};
            const keyToOptionKeys = {};
            const keyToPropInfo = {};

            const createFunctionToGetPropertyKey = function(propertyKey){
                return function( arrayOfNodesMatchingResults, arrayOfNodesToHiglights, arrayOfAdditionalMatchingResults){
                    return arrayOfAdditionalMatchingResults[propertyKey];
                }
            }
            
            allArraysOfAdditionalMatchingResults.map((arrayOfAdditionalMatchingResults, i)=>{
                for(let propInfo of arrayOfProperties){
                    const propertyKey =  arrayOfAdditionalMatchingResults[propInfo.key];
                    let optionsKeys = keyToOptionKeys[propInfo.key];
                    let optionsArray = keyToOptions[propInfo.key];
                    if(!optionsKeys){
                        optionsKeys = [];
                        optionsArray =  [];
                        keyToOptionKeys[propInfo.key] = optionsKeys;
                        keyToOptions[propInfo.key] = optionsArray;
                        keyToPropInfo[propInfo.key] = propInfo;
                    }
                    if(!optionsKeys.includes(propertyKey)){
                        optionsKeys.push(propertyKey);
                        optionsArray.push({key:propertyKey,label: getOptionLabelFunction(propInfo.key, propertyKey, arrayOfAdditionalMatchingResults)});
                    }
                }
                
            })
            const allfilterProperties = Object.keys(keyToOptions).map((propKey)=>{
                return {...keyToPropInfo[propKey], functionToGetPropertyKey: createFunctionToGetPropertyKey(propKey) , options: keyToOptions[propKey] };
            })

            let filterOptions = presetFilterOptions;
            if(!filterOptions){
                //create default filter
                filterOptions =  {};
                allfilterProperties.map(({key, label, functionToGetPropertyKey, options})=>{
                    let optionsSelected =  filterOptions[key];
                    if(!optionsSelected){
                        optionsSelected = [];
                        filterOptions[key] = optionsSelected;
                    }
                    filterOptions[key]  = options.map((optionInfo)=>{
                        return optionInfo.key;
                    }).filter((optionValue)=>{
                        if(mapOfOptionsToExclude && mapOfOptionsToExclude[key]){
                            return !mapOfOptionsToExclude[key].includes(optionValue);
                        }
                        return true;
                    });
                })
            }

            return {allfilterProperties, filterOptions}

        }
    },

    shouldSafeBeAvailableForCurrentSearchType : function(){
        return this.getSearchType() !== SEARCH_TYPE.SILENCES;
    },

    _shouldApplyImproveSafetyForCurrentSearchType : function(){
        // For AI_EDIT_SUGGESTIONS, respect the feature flag
        if(this.getSearchType() === SEARCH_TYPE.AI_EDIT_SUGGESTIONS){
            return ENABLE_IMPROVE_SAFETY_BY_DEFAULT_FOR_AI_SUGGESTIONS;
        }
        // For other search types, allow the feature to work (user can manually enable)
        return true;
    },

    doesSearchTypeNeedToBeAnalyzedForSilencesBeforeSearchResults : function(){
        return this.getSearchType() === SEARCH_TYPE.SILENCES || 
               (this.getSearchType() === SEARCH_TYPE.AI_EDIT_SUGGESTIONS && ENABLE_LONG_SILENCES_IN_AI_SUGGESTIONS);
    },

    applySearchGeneric : async function(operationId, searchParams, isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, forceReset, keepCurrentIndexInFocus, useCachedSearchResults, createFilterPropertiesFunction, filterFunction){
        if(forceReset || isSearchParamsChanged(this.getSearchParams(), searchParams)){
            const currentIndexOfNodeInFocus = this.getIndexOfNodeInFocus();
            if(!useCachedSearchResults){
                // Preserve dismissedResultIds before clearing
                const preservedDismissedResultIds = this.get("dismissedResultIds");
                this._clearSearch();
                // Restore dismissedResultIds after clearing
                if(preservedDismissedResultIds){
                    this.set("dismissedResultIds", preservedDismissedResultIds);
                }
            }
            this.set("searchParams", searchParams);
            this.setSearchOn(true);
            if(this.getSearchParams()){
                if(this.doesSearchTypeNeedToBeAnalyzedForSilencesBeforeSearchResults()){
                    await this._analyzeMediaForSilencesIfNeeded(MEDIA_ANALYSIS_REASON.SILENCE);
                }
                const searchResults = this.getSearchResultsGeneric(searchParams, isMatchingSearchFunction, shouldSearchResultsBeingValidated, isSearchParamsChanged, null, null, null, createFilterPropertiesFunction, filterFunction);
                if(this.shouldSafeBeAvailableForCurrentSearchType()){
                    if(this.isOnlyShowSafeCut()){
                        await this._applySafeTrimToSearchResults(searchResults);
                    } else if(this.getImproveSafetyWhenPossible() && this._shouldApplyImproveSafetyForCurrentSearchType()){
                        await this._applyImproveSafetyToSearchResults(searchResults);
                    }
                }
                if(!this._isSearchOperationValid(operationId)){
                    return null;
                }
                const allArraysOfNodesMatchingResults = searchResults.allArraysOfNodesMatchingResults;
                const allArraysOfNodesToHiglights = searchResults.allArraysOfNodesToHiglights;
                const allArraysOfAdditionalMatchingResults = searchResults.allArraysOfAdditionalMatchingResults;
                // Surface the safe-trim boundary info so downstream UI can read
                // it per-result. Note: the matching-results arrays above already
                // reflect the whole-node safe trim expansion, so apply callers
                // that use [array[0], array[last]] WILL delete the safe range.
                // The boundary info below carries extra ms-precise silence data
                // for future exact-boundary cutting work.
                const allSafeTrimBoundaries = searchResults.allSafeTrimBoundaries || [];
                this.set("allArraysOfNodesMatchingResults", allArraysOfNodesMatchingResults);
                this.set("allArraysOfNodesToHiglights", allArraysOfNodesToHiglights);
                this.set("allArraysOfAdditionalMatchingResults", allArraysOfAdditionalMatchingResults);
                this.set("allSafeTrimBoundaries", allSafeTrimBoundaries);
                this.set("searchRequestId", searchResults.id?searchResults.id: this._generateRandomSearchRequestId());

                const {filteredAllArraysOfNodesMatchingResults, filteredAllArraysOfNodesToHiglights, filteredAllArraysOfAdditionalMatchingResults} = searchResults.allfilterProperties &&  searchResults.filterFunction? searchResults.filterFunction(searchResults.filterOptions, allArraysOfNodesMatchingResults, allArraysOfNodesToHiglights, allArraysOfAdditionalMatchingResults):{filteredAllArraysOfNodesMatchingResults:allArraysOfNodesMatchingResults, filteredAllArraysOfNodesToHiglights: allArraysOfNodesToHiglights, filteredAllArraysOfAdditionalMatchingResults: allArraysOfAdditionalMatchingResults};
                
                filteredAllArraysOfNodesToHiglights.forEach((function(currentNodesToHighlights){
                    currentNodesToHighlights.forEach(function(nodeToHighlight){
                        nodeToHighlight.setSearchHightlighted(true);
                    })
                }).bind(this));
                searchResults.filteredAllArraysOfNodesMatchingResults = filteredAllArraysOfNodesMatchingResults;
                searchResults.filteredAllArraysOfNodesToHiglights = filteredAllArraysOfNodesToHiglights;
                searchResults.filteredAllArraysOfAdditionalMatchingResults = filteredAllArraysOfAdditionalMatchingResults;
                this.set("filteredAllArraysOfNodesMatchingResults", filteredAllArraysOfNodesMatchingResults);
                this.set("filteredAllArraysOfNodesToHiglights", filteredAllArraysOfNodesToHiglights);
                this.set("filteredAllArraysOfAdditionalMatchingResults", filteredAllArraysOfAdditionalMatchingResults);
                this.set("allFilterProperties", searchResults.allfilterProperties);
                this.set("filterOptions", searchResults.filterOptions);
                this.set("filterFunction", searchResults.filterFunction);
                
                this.moveToNextFoundNode(keepCurrentIndexInFocus, currentIndexOfNodeInFocus);
                this._cachedSearchResults = searchResults;
                return searchResults;
            }
        }
    },

    updateFilterOptions : function(newFilterOptions){
        this.getAllArraysOfNodesToHiglights().forEach(function(arrayOfNodes){
            if(arrayOfNodes){
                arrayOfNodes.forEach(function(node){
                    node.setSearchHightlighted(false);
                })
            }
        })
        this.set("filterOptions", newFilterOptions);
        if(this.getFilterFunction()){
            const {filteredAllArraysOfNodesMatchingResults, filteredAllArraysOfNodesToHiglights, filteredAllArraysOfAdditionalMatchingResults} = this.getFilterFunction()(this.getFilterOptions(), this.get("allArraysOfNodesMatchingResults"), this.get("allArraysOfNodesToHiglights"), this.get("allArraysOfAdditionalMatchingResults"));
                    
            filteredAllArraysOfNodesToHiglights.forEach((function(currentNodesToHighlights){
                currentNodesToHighlights.forEach(function(nodeToHighlight){
                    nodeToHighlight.setSearchHightlighted(true);
                })
            }).bind(this));
            
            this.set("filteredAllArraysOfNodesMatchingResults", filteredAllArraysOfNodesMatchingResults);
            this.set("filteredAllArraysOfNodesToHiglights", filteredAllArraysOfNodesToHiglights);
            this.set("filteredAllArraysOfAdditionalMatchingResults", filteredAllArraysOfAdditionalMatchingResults);

            if(this.getIndexOfNodeInFocus() >= filteredAllArraysOfNodesMatchingResults.length){
                this.moveToNextFoundNode(true, 0);
            }else{
                this.moveToNextFoundNode(true, this.getIndexOfNodeInFocus());
            }
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("sequencer", 'updateSearchFilter', 'Update search filter',{ searchType: this.getSearchType(), searchRequestId: this.getSearchRequestId(), newFilterOptions});
            }
        }
    },

    _generateRandomSearchRequestId: function(){
        const timestampHex = new Date().getTime().toString(16);
        const randomHex = `${Math.random().toString(16).slice(2)}${Utils.getInstance().generateRandomId().replace(/[^a-f0-9]/gi, "")}`;
        return `${timestampHex}${randomHex}`.slice(0, 24).padEnd(24, "0");
    },

    getSearchResultsForDisfluencies : function(){

    },


    getAllArraysOfNodesMatchingResults: function(){
        //return this.get("allArraysOfNodesMatchingResults");
        return this.getFilteredAllArraysOfNodesMatchingResults();
    },

    getAllArraysOfNodesToHiglights: function(){
        //return this.get("allArraysOfNodesToHiglights");
        return this.getFilteredAllArraysOfNodesToHiglights();
    },

    getAllArraysOfAdditionalMatchingResults: function(){
        //return this.get("allArraysOfAdditionalMatchingResults");
        return this.getFilteredAllArraysOfAdditionalMatchingResults()
    },

    getFilteredAllArraysOfNodesMatchingResults: function(){
        return this.get("filteredAllArraysOfNodesMatchingResults");
    },

    getFilteredAllArraysOfNodesToHiglights: function(){
        return this.get("filteredAllArraysOfNodesToHiglights");
    },

    getFilteredAllArraysOfAdditionalMatchingResults: function(){
        return this.get("filteredAllArraysOfAdditionalMatchingResults");
    },

    getSearchRequestId : function(){
        return this.get("searchRequestId");
    },

    getAllfilterProperties : function(){
        return this.get("allFilterProperties");
    },

    getFilterOptions : function(){
        return this.get("filterOptions");
    },

    getFilterFunction : function(){
        return this.get("filterFunction");
    },


    applyActionToCurrentResultInFocus : function(){
        // Called when an action is applied to current result
        if(this.isSearchOn() && this.getAutoJumpToNext()){
            // If auto-jump is enabled, move to next result after applying action
            this.moveToNextFoundNode();
        }
    },

    deleteSelectedNodesWithAutoJumpLogic : function(startNode, endNode, deletionSource, additionalMatchingResultForFeedback){
        if(this._sequencer && typeof this._sequencer.hasMutationAccess === "function" && !this._sequencer.hasMutationAccess()){
            return null;
        }

        // Define shared tracking details
        let details = { success: true };
        const nodeArrayForFeedback = this._getNodeArrayFromRange(startNode, endNode);
        
        // Count nodes being deleted for tracking
        if (this.isSearchOn()) {
            let nodeCount = 0;
            let currentNode = startNode;
            while(currentNode && currentNode !== endNode.getNext()) {
                nodeCount++;
                currentNode = currentNode.getNext();
            }
            details.changeCount = nodeCount;
        }
        
        // Track AI operation applied for Facebook based on current search type
        if (window.FacebookEventTrackingHelper && this.isSearchOn()) {
            const searchType = this.getSearchType();
            let toolName = 'Unknown_AI_Tool';
            
            switch(searchType) {
                case SEARCH_TYPE.DISFLUENCY_SEARCH:
                    toolName = 'Remove_Repeated_Words';
                    break;
                case SEARCH_TYPE.FILLER_WORDS:
                    toolName = 'Remove_Filler_Words';
                    break;
                case SEARCH_TYPE.SILENCES:
                    toolName = 'Remove_Silences';
                    break;
                case SEARCH_TYPE.AI_EDIT_SUGGESTIONS:
                    toolName = 'DeepCut_Analysis';
                    break;
            }
            
            window.FacebookEventTrackingHelper.getInstance().trackAIOperationApplied(toolName, details);
        }
        
        // Track AI operation applied for trebbleAnalyticsHelper
        if(window.trebbleAnalyticsHelper && this.isSearchOn()) {
            const searchType = this.getSearchType();
            let eventAction = 'aiOperationApplied';
            let eventDescription = 'AI operation applied';
            
            switch(searchType) {
                case SEARCH_TYPE.DISFLUENCY_SEARCH:
                    eventAction = 'removeRepeatedWords';
                    eventDescription = 'Removed repeated words';
                    break;
                case SEARCH_TYPE.FILLER_WORDS:
                    eventAction = 'removeFillerWords';
                    eventDescription = 'Removed filler words';
                    break;
                case SEARCH_TYPE.SILENCES:
                    eventAction = 'removeSilences';
                    eventDescription = 'Removed silences';
                    break;
                case SEARCH_TYPE.AI_EDIT_SUGGESTIONS:
                    eventAction = 'applyDeepCutSuggestions';
                    eventDescription = 'Applied DeepCut suggestions';
                    break;
            }
            
            window.trebbleAnalyticsHelper.trackEvent("sequencer", eventAction, eventDescription, {
                changeCount: details.changeCount,
                success: details.success
            });
        }
        
        // Perform the deletion
        const deletedNode = this._sequencer.deleteSelectedNodes(startNode, endNode, deletionSource);
        if(deletedNode){
            if(additionalMatchingResultForFeedback){
                this._recordSuggestionFeedbackForAdditionalMatchingResult(SUGGESTION_FEEDBACK_ACTION.APPLIED, additionalMatchingResultForFeedback, nodeArrayForFeedback);
            }else{
                this._recordSuggestionFeedbackForDeletionSource(SUGGESTION_FEEDBACK_ACTION.APPLIED, deletionSource, nodeArrayForFeedback);
            }
        }
        
        if(this.isSearchOn()){
            if(this.getAutoJumpToNext()){
                // Auto-jump enabled: use default behavior (dismissCurrentResultInFocus handles this)
                this.dismissCurrentResultInFocus(true);
            } else {
                // Auto-jump disabled: let the view keep focus near the edited region
                if(deletedNode){
                    this.trigger("selectDeletedNode", deletedNode);
                }
                // Remove the current result from search results without moving to next
                this._removeCurrentResultFromSearch();
            }
        }
        
        return deletedNode;
    },

    // Centralized function to set nodesInFocus with proper auto-jump logic
    _setNodesInFocusRespectingAutoJump : function(nodes, bypassAutoJumpCheck = false){
        if(this.isSearchOn()){
            const shouldUpdateFocus = this.getAutoJumpToNext() || bypassAutoJumpCheck;
            if(shouldUpdateFocus){
                this.set("nodesInFocus", nodes);
            } else {
                // Don't update nodesInFocus but trigger index change for UI counter updates
                this.trigger("change:indexOfNodeInFocus", this.getIndexOfNodeInFocus());
            }
        }
    },

    _removeCurrentResultFromSearch : function(){
        // Remove current result from search without auto-jumping to next
        if(this.isSearchOn()){
            const currentIndex = this.getIndexOfNodeInFocus();
            const arrayOfNodes = this.get("nodesInFocus");
            const arrayOfResults = this.getAllArraysOfNodesMatchingResults()[currentIndex];
            
            if(arrayOfNodes){
                arrayOfNodes.forEach(function(node){
                    node.setSearchHightlighted(false);
                });
            }
            
            // Add to dismissed results BEFORE removing
            if(arrayOfResults){
                this._addToDismissedResults(arrayOfResults);
            }
            
            // Remove from arrays
            this.getAllArraysOfNodesToHiglights().splice(currentIndex, 1);
            this.getAllArraysOfNodesMatchingResults().splice(currentIndex, 1);
            this.getAllArraysOfAdditionalMatchingResults() && this.getAllArraysOfAdditionalMatchingResults().length > currentIndex? this.getAllArraysOfAdditionalMatchingResults().splice(currentIndex, 1):null
            
            // When auto-jump is OFF, decrement index by 1 for better UX
            // This way, hitting "next" will go to what was originally the next result
            if(this.getAllArraysOfNodesToHiglights().length == 0){
                this.setIndexOfNodeInFocus(-1);
            } else {
                let newIndex = this.getIndexOfNodeInFocus() - 1;
                // Make sure index is valid
                if(newIndex < 0){
                    newIndex = 0;
                } else if(newIndex >= this.getAllArraysOfNodesToHiglights().length){
                    newIndex = this.getAllArraysOfNodesToHiglights().length - 1;
                }
                this.setIndexOfNodeInFocus(newIndex);
            }
            // Always trigger index change for UI counter updates without updating nodesInFocus
            this.trigger("change:indexOfNodeInFocus", this.getIndexOfNodeInFocus());
        }
    },

    _generateResultId : function(nodeArray){
        // Generate a unique ID for a search result based on its nodes
        if(!nodeArray || nodeArray.length === 0){
            return null;
        }
        // Use first and last node CIDs to create a unique identifier
        const firstNodeCid = nodeArray[0].getCid();
        const lastNodeCid = nodeArray[nodeArray.length - 1].getCid();
        const nodeCount = nodeArray.length;
        return `${firstNodeCid}_${lastNodeCid}_${nodeCount}`;
    },

    _addToDismissedResults : function(resultArray){
        // Add a result to the dismissed results set
        const resultId = this._generateResultId(resultArray);
        if(resultId){
            const dismissedResultIds = this.get("dismissedResultIds") || new Set();
            dismissedResultIds.add(resultId);
            this.set("dismissedResultIds", dismissedResultIds);
        }
    },

    _isResultDismissed : function(resultArray){
        // Check if a result has been dismissed
        const resultId = this._generateResultId(resultArray);
        if(!resultId){
            return false;
        }
        const dismissedResultIds = this.get("dismissedResultIds") || new Set();
        const isDismissed = dismissedResultIds.has(resultId);
        return isDismissed;
    },


    dismissSpecificSearchResult : function(resultIndex, skipSuggestionFeedback){
        if(this.isSearchOn() && resultIndex >= 0 && resultIndex < this.getAllArraysOfNodesToHiglights().length){
            
            // Get the nodes for this specific result before removing
            const arrayOfNodes = this.getAllArraysOfNodesToHiglights()[resultIndex];
            const arrayOfResults = this.getAllArraysOfNodesMatchingResults()[resultIndex];
            const additionalMatchingResult = this.getAllArraysOfAdditionalMatchingResults() && this.getAllArraysOfAdditionalMatchingResults().length > resultIndex ? this.getAllArraysOfAdditionalMatchingResults()[resultIndex] : null;
            
            if(arrayOfNodes){
                arrayOfNodes.forEach(function(node){
                    node.setSearchHightlighted(false);
                });
            }
            
            // Add to dismissed results BEFORE removing
            if(arrayOfResults){
                this._addToDismissedResults(arrayOfResults);
            }
            if(!skipSuggestionFeedback){
                this._recordSuggestionFeedbackForAdditionalMatchingResult(SUGGESTION_FEEDBACK_ACTION.DISMISSED, additionalMatchingResult, arrayOfResults);
            }
            
            // Remove from filtered arrays at the specific index
            this.getAllArraysOfNodesToHiglights().splice(resultIndex, 1);
            this.getAllArraysOfNodesMatchingResults().splice(resultIndex, 1);
            this.getAllArraysOfAdditionalMatchingResults() && this.getAllArraysOfAdditionalMatchingResults().length > resultIndex ? this.getAllArraysOfAdditionalMatchingResults().splice(resultIndex, 1) : null;
            
            // Adjust the current focus index based on what was removed
            const currentIndex = this.getIndexOfNodeInFocus();
            if(this.getAllArraysOfNodesToHiglights().length == 0){
                // No more results
                this.set("nodesInFocus", null);
                this.setIndexOfNodeInFocus(-1);
            } else if(resultIndex < currentIndex){
                // Removed item was before current focus, so decrement current index
                this.setIndexOfNodeInFocus(currentIndex - 1);
                this.trigger("change:indexOfNodeInFocus", this.getIndexOfNodeInFocus());
            } else if(resultIndex == currentIndex){
                // Removed the currently focused item - ALWAYS jump for dismiss/apply actions
                let newIndex = currentIndex;
                if(newIndex >= this.getAllArraysOfNodesToHiglights().length){
                    newIndex = this.getAllArraysOfNodesToHiglights().length - 1;
                }
                this.setIndexOfNodeInFocus(newIndex);
                this._setNodesInFocusRespectingAutoJump(this.getAllArraysOfNodesToHiglights()[newIndex], true); // Always bypass auto-jump check
            } else {
                // Removed item was after current focus, no change to current index needed
                // But trigger update for UI counter
                this.trigger("change:indexOfNodeInFocus", this.getIndexOfNodeInFocus());
            }
            // Trigger a generic change so React components (via useBackboneModel) re-render
            // after in-place array mutations above
            this.trigger("change");
        }

    },

    dismissCurrentResultInFocus : function(skipSuggestionFeedback){
        if(this.isSearchOn()){
            const currentIndex = this.getIndexOfNodeInFocus();
            const arrayOfNodes = this.get("nodesInFocus");
            const arrayOfResults = this.getAllArraysOfNodesMatchingResults()[currentIndex];
            const additionalMatchingResult = this.getAllArraysOfAdditionalMatchingResults() && this.getAllArraysOfAdditionalMatchingResults().length > currentIndex ? this.getAllArraysOfAdditionalMatchingResults()[currentIndex] : null;
            
            if(arrayOfNodes){
                arrayOfNodes.forEach(function(node){
                    node.setSearchHightlighted(false);
                });
            }
            
            // Add to dismissed results BEFORE removing
            if(arrayOfResults){
                this._addToDismissedResults(arrayOfResults);
            }
            if(!skipSuggestionFeedback){
                this._recordSuggestionFeedbackForAdditionalMatchingResult(SUGGESTION_FEEDBACK_ACTION.DISMISSED, additionalMatchingResult, arrayOfResults);
            }
            
            this.getAllArraysOfNodesToHiglights().splice(currentIndex, 1);
            this.getAllArraysOfNodesMatchingResults().splice(currentIndex, 1);
            this.getAllArraysOfAdditionalMatchingResults() && this.getAllArraysOfAdditionalMatchingResults().length > currentIndex? this.getAllArraysOfAdditionalMatchingResults().splice(currentIndex, 1):null
            
            // Handle focus updates based on remaining results and auto-jump setting
            if(this.getAllArraysOfNodesToHiglights().length == 0){
                // No more results
                this.set("nodesInFocus", null);
                this.setIndexOfNodeInFocus(-1);
            } else {
                if(this.getAutoJumpToNext()){
                    // Auto-jump ON: move to next result (current behavior)
                    if(this.getIndexOfNodeInFocus() < this.getAllArraysOfNodesToHiglights().length){
                        this._setNodesInFocusRespectingAutoJump(this.getAllArraysOfNodesToHiglights()[this.getIndexOfNodeInFocus()]);
                    } else {
                        // Current index is out of bounds, go to previous result
                        if(this.getIndexOfNodeInFocus() - 1  >= 0){
                            this.setIndexOfNodeInFocus(this.getIndexOfNodeInFocus() - 1);
                            this._setNodesInFocusRespectingAutoJump(this.getAllArraysOfNodesToHiglights()[this.getIndexOfNodeInFocus()]);
                        }
                    }
                } else {
                    // Auto-jump OFF: decrement index for better UX (same as _removeCurrentResultFromSearch)
                    let newIndex = this.getIndexOfNodeInFocus() - 1;
                    // Make sure index is valid
                    if(newIndex < 0){
                        newIndex = 0;
                    } else if(newIndex >= this.getAllArraysOfNodesToHiglights().length){
                        newIndex = this.getAllArraysOfNodesToHiglights().length - 1;
                    }
                    
                    const oldIndex = this.getIndexOfNodeInFocus();
                    this.setIndexOfNodeInFocus(newIndex);
                    
                    // Always trigger change event, even if index didn't change (important for UI updates)
                    this.trigger("change:indexOfNodeInFocus", this.getIndexOfNodeInFocus());
                    
                }
            }
        }
    },


    moveToNextFoundNode : function(forceIndexOfNodeInFocus, newIndeOfNodeInFocus, bypassAutoJumpCheck = false){
        if(this.isSearchOn()){
            // Only update nodesInFocus if auto-jump is ON or we're explicitly bypassing the check
            const shouldUpdateFocus = this.getAutoJumpToNext() || bypassAutoJumpCheck;
            
            if(forceIndexOfNodeInFocus && newIndeOfNodeInFocus < this.getAllArraysOfNodesToHiglights().length){
                if(newIndeOfNodeInFocus < 0){
                    newIndeOfNodeInFocus =  0;
                }
                this.setIndexOfNodeInFocus(newIndeOfNodeInFocus);
                this._setNodesInFocusRespectingAutoJump(this.getAllArraysOfNodesToHiglights()[this.getIndexOfNodeInFocus()], bypassAutoJumpCheck);
            }else{
                // Handle "no selection" state (-1)
                let nextIndex;
                if(this.getIndexOfNodeInFocus() === -1){
                    // If no selection, start from beginning
                    nextIndex = 0;
                } else {
                    nextIndex = this.getIndexOfNodeInFocus() + 1;
                }
                
                if(nextIndex < this.getAllArraysOfNodesToHiglights().length){
                    this.setIndexOfNodeInFocus(nextIndex);
                    this._setNodesInFocusRespectingAutoJump(this.getAllArraysOfNodesToHiglights()[this.getIndexOfNodeInFocus()], bypassAutoJumpCheck);
                }else{
                    if(this.getAllArraysOfNodesToHiglights().length == 0){
                        this.setIndexOfNodeInFocus(-1);
                        this._setNodesInFocusRespectingAutoJump(null, bypassAutoJumpCheck);
                    }
                }
            }
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("sequencer", 'moveToNextSearchFound', 'Move to next search found',{ searchType: this.getSearchType(), searchRequestId: this.getSearchRequestId()});
            }
        }
    },

    moveToNextFoundNodeWithPreview : function(){
        this.moveToNextFoundNode(false, false, true); // bypassAutoJumpCheck = true for navigation
        this._triggerAutoPreview();
    },

    /*getSequencerNodeCurrentlyInFocus : function(){
        if(this.isSearchOn()){
            return this.get("nodeInFocus")
        }else{
            return null;
        }
    },*/

    getSequencerNodesCurrentlyInFocus : function(){
        if(this.isSearchOn()){
            return this.get("nodesInFocus")
        }else{
            return null;
        }
    },


    moveToPreviousFoundNode : function(bypassAutoJumpCheck = true){
        if(this.isSearchOn()){
            // Only update nodesInFocus if auto-jump is ON or we're explicitly bypassing the check
            const shouldUpdateFocus = this.getAutoJumpToNext() || bypassAutoJumpCheck;
            
            // Handle "no selection" state (-1)
            let prevIndex;
            if(this.getIndexOfNodeInFocus() === -1){
                // If no selection, go to the last result
                prevIndex = this.getAllArraysOfNodesToHiglights().length - 1;
            } else {
                prevIndex = this.getIndexOfNodeInFocus() - 1;
            }
            
            if(prevIndex >= 0 && prevIndex < this.getAllArraysOfNodesToHiglights().length){
                this.setIndexOfNodeInFocus(prevIndex);
                this._setNodesInFocusRespectingAutoJump(this.getAllArraysOfNodesToHiglights()[this.getIndexOfNodeInFocus()], bypassAutoJumpCheck);
            }else{
                if(this.getAllArraysOfNodesToHiglights().length == 0){
                    this.setIndexOfNodeInFocus(-1);
                    this._setNodesInFocusRespectingAutoJump(null, bypassAutoJumpCheck);
                }
            }
            if(window.trebbleAnalyticsHelper){
                window.trebbleAnalyticsHelper.trackEvent("sequencer", 'moveToPreviousSearchFound', 'Move to previous search found',{ searchType: this.getSearchType(), searchRequestId: this.getSearchRequestId()});
            }
        }
    },

    moveToPreviousFoundNodeWithPreview : function(){
        this.moveToPreviousFoundNode(true); // bypassAutoJumpCheck = true for navigation
        this._triggerAutoPreview();
    },

    _triggerAutoPreview : function(){
        // Auto-preview functionality when navigating between search results
        if(this.isSearchOn() && (this.getPreviewWithOperation() || this.getPreviewWithoutOperation())){
            const nodesInFocus = this.getSequencerNodesCurrentlyInFocus();
            if(nodesInFocus && nodesInFocus.length > 0){
                const startNode = nodesInFocus[0];
                const endNode = nodesInFocus[nodesInFocus.length - 1];
                const playBySentences = this.getSearchType() === SEARCH_TYPE.EDIT_BOUNDARIES;
                
                if(this.getPreviewWithOperation()){
                    // Play with operation applied (deleted content not played)
                    SequencerRendererUtils.getInstance().playWithoutSelectionButtonClick(
                        this._sequencer, startNode, endNode, playBySentences, this._getNumberOfWordsBeforeAndAfterToPlay()
                    );
                } else if(this.getPreviewWithoutOperation()){
                    // Play without operation applied (deleted content still played)
                    SequencerRendererUtils.getInstance().playWithSelectionButtonClick(
                        this._sequencer, startNode, endNode, playBySentences, false, this._getNumberOfWordsBeforeAndAfterToPlay()
                    );
                }
            }
        }
    },

    _getNumberOfWordsBeforeAndAfterToPlay : function(){
        if(this.getSearchType() === SEARCH_TYPE.EDIT_BOUNDARIES){
            return 10;
        }
        if(this.getSearchType() === SEARCH_TYPE.SEMANTIC_SEARCH){
            return 10;
        }
        if(this.getSearchType() === SEARCH_TYPE.AI_EDIT_SUGGESTIONS){
            return 10;
        }
        return 4;
    },

    /*_addNodeToArrayOfMatchingNodes : function(matchingNodeToAdd){
        if(matchingNodeToAdd){
            matchingNodeToAdd.setSearchHightlighted(true);
            this._allArraysOfNodesMatchingResults.push(matchingNodeToAdd);
        }
    },*/

    getNumberOfSearchNodesFound: function(){
        return this.getAllArraysOfNodesMatchingResults().length;
    },

    getIndexOfNodeInFocus: function(){
        return this.getNumberOfSearchNodesFound() > 0? this.get("indexOfNodeInFocus"): -1;
    },

    setIndexOfNodeInFocus: function(indexOfNodeInFocus){
        this.set("indexOfNodeInFocus", indexOfNodeInFocus);
    },

    canMoveToNextResult: function(){
        if(this.getNumberOfSearchNodesFound() === 0) return false;
        
        // If no selection (-1), next is available if there are results
        if(this.getIndexOfNodeInFocus() === -1) return true;
        
        // Otherwise, check if we can move to next normally
        return this.getIndexOfNodeInFocus() + 1 < this.getNumberOfSearchNodesFound();
    },

    canMoveToPreviousResult: function(){
        if(this.getNumberOfSearchNodesFound() === 0) return false;
        
        // If no selection (-1), previous is available if there are results
        if(this.getIndexOfNodeInFocus() === -1) return true;
        
        // Otherwise, check if we can move to previous normally
        return this.getIndexOfNodeInFocus() > 0;
    },

    async _analyzeMediaForSilencesIfNeeded(reason){
        if(this.getSequencer().doesMediaNeedToBeAnalyzedForSilences()){
            this.setIsMediaAnalyzedForSilences(true, reason || MEDIA_ANALYSIS_REASON.SILENCE);
            await this.getSequencer().analyzeAllMediaForSilences(null);
            this.setIsMediaAnalyzedForSilences(false);
        }
    },

    /**
     * Improves safety of search results when possible, but keeps all results (safe and unsafe).
     * @param {Object} searchResults - The search results object to modify.
     * @private
     */
    async _applyImproveSafetyToSearchResults(searchResults) {
        await this._analyzeMediaForSilencesIfNeeded(MEDIA_ANALYSIS_REASON.IMPROVE_SAFETY);
        const allArraysOfNodesToHiglightsSafetyImproved = [];
        const allArraysOfNodesMatchingResultsSafetyImproved = [];
        const allArraysOfAdditionalMatchingResultsSafetyImproved = [];
        // Optionally collect boundary info for diagnostics or UI
        const allSafeTrimBoundaries = [];
        const allHighlightSafeTrimBoundaries = [];
        
        // Generate fallback parameters for safe trim operations
        const fallbackParameters = SequencerNodeUtils.getInstance().generateSafeTrimFallbackParameters(
            SAFE_TRIM_LEFT_BUFFER, 
            SAFE_TRIM_RIGHT_BUFFER, 
            SAFE_TRIM_LEFT_SILENCE, 
            SAFE_TRIM_RIGHT_SILENCE
        );

        searchResults.allArraysOfNodesMatchingResults.forEach((arrayOfNodesMatchingResults, index) => {
            // Check if this result is a silence result (type: LONG_SILENCES)
            const additionalInfo = searchResults.allArraysOfAdditionalMatchingResults[index];
            const isSilenceResult = additionalInfo && additionalInfo.type === Utils.getInstance().getMediaTranscriptionAISearchQueryPresets().LONG_SILENCES;
            
            if (isSilenceResult) {
                // Silence results are inherently safe to cut - no need for safe trim analysis
                allArraysOfNodesMatchingResultsSafetyImproved.push(arrayOfNodesMatchingResults);
                allArraysOfNodesToHiglightsSafetyImproved.push(searchResults.allArraysOfNodesToHiglights[index]);
                if(searchResults.allArraysOfAdditionalMatchingResults.length > index){
                    allArraysOfAdditionalMatchingResultsSafetyImproved.push(searchResults.allArraysOfAdditionalMatchingResults[index]);
                }
                // Add dummy boundary info for consistency
                allSafeTrimBoundaries.push({
                    left: { node: arrayOfNodesMatchingResults[0], accumulatedSilence: 0, safeToCut: true },
                    right: { node: arrayOfNodesMatchingResults[arrayOfNodesMatchingResults.length - 1], accumulatedSilence: 0, safeToCut: true }
                });
                allHighlightSafeTrimBoundaries.push({
                    left: { node: searchResults.allArraysOfNodesToHiglights[index][0], accumulatedSilence: 0, safeToCut: true },
                    right: { node: searchResults.allArraysOfNodesToHiglights[index][searchResults.allArraysOfNodesToHiglights[index].length - 1], accumulatedSilence: 0, safeToCut: true }
                });
            } else {
                // Try to apply safe trim to improve safety
                const safeTrimResult = SequencerNodeUtils.getInstance().getSafeTrimSequencerNodesBoundariesFromArrayOfSequencerNodesWithFallback(arrayOfNodesMatchingResults, fallbackParameters);

                if(safeTrimResult.nodes && safeTrimResult.nodes.length > 0){
                    // Safe trim succeeded - use improved version. The pushed array
                    // already spans from the left silence boundary node to the right
                    // silence boundary node (whole-node resolution), so downstream
                    // apply callers that delete [array[0], array[last]] WILL delete
                    // the safe range. ms-precise splitting within boundary nodes is
                    // tracked in the architectural CutPlan work and is out of scope
                    // of this whole-node apply path.
                    allArraysOfNodesMatchingResultsSafetyImproved.push(safeTrimResult.nodes);
                    allSafeTrimBoundaries.push({left: safeTrimResult.left, right: safeTrimResult.right, leftSilence: safeTrimResult.leftSilence, rightSilence: safeTrimResult.rightSilence});

                    // Also improve highlight result if possible
                    const highlightSafeTrimResult = SequencerNodeUtils.getInstance().getSafeTrimSequencerNodesBoundariesFromArrayOfSequencerNodesWithFallback(searchResults.allArraysOfNodesToHiglights[index], fallbackParameters);
                    allArraysOfNodesToHiglightsSafetyImproved.push(highlightSafeTrimResult.nodes);
                    allHighlightSafeTrimBoundaries.push({left: highlightSafeTrimResult.left, right: highlightSafeTrimResult.right, leftSilence: highlightSafeTrimResult.leftSilence, rightSilence: highlightSafeTrimResult.rightSilence});
                } else {
                    // Safe trim failed - keep original unsafe result. Preserve the
                    // ACTUAL walk result in allSafeTrimBoundaries (previously a
                    // dummy first/last-node object was pushed here, discarding the
                    // real computed boundary data). safeTrimResult.left/right still
                    // carry the nodes the walk reached plus accumulatedSilence, which
                    // is useful for diagnostic UI and future ms-precision work.
                    allArraysOfNodesMatchingResultsSafetyImproved.push(arrayOfNodesMatchingResults);
                    allArraysOfNodesToHiglightsSafetyImproved.push(searchResults.allArraysOfNodesToHiglights[index]);
                    allSafeTrimBoundaries.push({
                        left: safeTrimResult.left || { node: arrayOfNodesMatchingResults[0], accumulatedSilence: 0, safeToCut: false },
                        right: safeTrimResult.right || { node: arrayOfNodesMatchingResults[arrayOfNodesMatchingResults.length - 1], accumulatedSilence: 0, safeToCut: false }
                    });
                    allHighlightSafeTrimBoundaries.push({
                        left: { node: searchResults.allArraysOfNodesToHiglights[index][0], accumulatedSilence: 0, safeToCut: false },
                        right: { node: searchResults.allArraysOfNodesToHiglights[index][searchResults.allArraysOfNodesToHiglights[index].length - 1], accumulatedSilence: 0, safeToCut: false }
                    });
                }

                // Always keep additional matching results
                if(searchResults.allArraysOfAdditionalMatchingResults.length > index){
                    allArraysOfAdditionalMatchingResultsSafetyImproved.push(searchResults.allArraysOfAdditionalMatchingResults[index]);
                }
            }
        });
        
        // Update search results with safety-improved versions
        searchResults.allArraysOfNodesToHiglights = allArraysOfNodesToHiglightsSafetyImproved;
        searchResults.allArraysOfNodesMatchingResults = allArraysOfNodesMatchingResultsSafetyImproved;
        searchResults.allArraysOfAdditionalMatchingResults = allArraysOfAdditionalMatchingResultsSafetyImproved;
        // Optionally, attach the boundary info arrays to searchResults for future use
        searchResults.allSafeTrimBoundaries = allSafeTrimBoundaries;
        searchResults.allHighlightSafeTrimBoundaries = allHighlightSafeTrimBoundaries;
    },

    /**
     * Applies safe trim logic to the search results, updating the arrays in-place.
     * @param {Object} searchResults - The search results object to modify.
     * @private
     */
    async _applySafeTrimToSearchResults(searchResults) {
        await this._analyzeMediaForSilencesIfNeeded(MEDIA_ANALYSIS_REASON.SAFE_CUT);
        const allArraysOfNodesToHiglightsSafeTrim = [];
        const allArraysOfNodesMatchingResultsSafeTrim = [];
        const allArraysOfAdditionalMatchingResultsSafeTrim = [];
        // Optionally collect boundary info for diagnostics or UI
        const allSafeTrimBoundaries = [];
        const allHighlightSafeTrimBoundaries = [];
        // Generate fallback parameters for safe trim operations
        const fallbackParameters = SequencerNodeUtils.getInstance().generateSafeTrimFallbackParameters(
            SAFE_TRIM_LEFT_BUFFER, 
            SAFE_TRIM_RIGHT_BUFFER, 
            SAFE_TRIM_LEFT_SILENCE, 
            SAFE_TRIM_RIGHT_SILENCE
        );

        searchResults.allArraysOfNodesMatchingResults.forEach((arrayOfNodesMatchingResults, index) => {
            // Check if this result is a silence result (type: LONG_SILENCES)
            const additionalInfo = searchResults.allArraysOfAdditionalMatchingResults[index];
            const isSilenceResult = additionalInfo && additionalInfo.type === Utils.getInstance().getMediaTranscriptionAISearchQueryPresets().LONG_SILENCES;
            
            if (isSilenceResult) {
                // Silence results are inherently safe to cut - no need for safe trim analysis
                allArraysOfNodesMatchingResultsSafeTrim.push(arrayOfNodesMatchingResults);
                allArraysOfNodesToHiglightsSafeTrim.push(searchResults.allArraysOfNodesToHiglights[index]);
                if(searchResults.allArraysOfAdditionalMatchingResults.length > index){
                    allArraysOfAdditionalMatchingResultsSafeTrim.push(searchResults.allArraysOfAdditionalMatchingResults[index]);
                }
                // Add dummy boundary info for consistency
                allSafeTrimBoundaries.push({
                    left: { node: arrayOfNodesMatchingResults[0], accumulatedSilence: 0, safeToCut: true },
                    right: { node: arrayOfNodesMatchingResults[arrayOfNodesMatchingResults.length - 1], accumulatedSilence: 0, safeToCut: true }
                });
                allHighlightSafeTrimBoundaries.push({
                    left: { node: searchResults.allArraysOfNodesToHiglights[index][0], accumulatedSilence: 0, safeToCut: true },
                    right: { node: searchResults.allArraysOfNodesToHiglights[index][searchResults.allArraysOfNodesToHiglights[index].length - 1], accumulatedSilence: 0, safeToCut: true }
                });
            } else {
                // Apply normal safe trim logic for non-silence results
                const safeTrimResult = SequencerNodeUtils.getInstance().getSafeTrimSequencerNodesBoundariesFromArrayOfSequencerNodesWithFallback(arrayOfNodesMatchingResults, fallbackParameters);
                
                // Only proceed if safe trim was successful
                if(safeTrimResult.nodes && safeTrimResult.nodes.length > 0){
                    allArraysOfNodesMatchingResultsSafeTrim.push(safeTrimResult.nodes);
                    allSafeTrimBoundaries.push({left: safeTrimResult.left, right: safeTrimResult.right, leftSilence: safeTrimResult.leftSilence, rightSilence: safeTrimResult.rightSilence});
                    
                    // Only calculate highlight result if main result was successful
                    const highlightSafeTrimResult = SequencerNodeUtils.getInstance().getSafeTrimSequencerNodesBoundariesFromArrayOfSequencerNodesWithFallback(searchResults.allArraysOfNodesToHiglights[index], fallbackParameters);
                    allArraysOfNodesToHiglightsSafeTrim.push(highlightSafeTrimResult.nodes);
                    allHighlightSafeTrimBoundaries.push({left: highlightSafeTrimResult.left, right: highlightSafeTrimResult.right, leftSilence: highlightSafeTrimResult.leftSilence, rightSilence: highlightSafeTrimResult.rightSilence});
                    
                    if(searchResults.allArraysOfAdditionalMatchingResults.length > index){
                        allArraysOfAdditionalMatchingResultsSafeTrim.push(searchResults.allArraysOfAdditionalMatchingResults[index]);
                    }
                }
            }
        });
        searchResults.allArraysOfNodesToHiglights = allArraysOfNodesToHiglightsSafeTrim;
        searchResults.allArraysOfNodesMatchingResults = allArraysOfNodesMatchingResultsSafeTrim;
        searchResults.allArraysOfAdditionalMatchingResults = allArraysOfAdditionalMatchingResultsSafeTrim;
        // Optionally, attach the boundary info arrays to searchResults for future use
        searchResults.allSafeTrimBoundaries = allSafeTrimBoundaries;
        searchResults.allHighlightSafeTrimBoundaries = allHighlightSafeTrimBoundaries;
    },

    _generateSearchOperationId : function(){
        this._searchOperationCounter += 1;
        return 'search_op_' + Date.now() + '_' + this._searchOperationCounter;
    },

    _invalidateCurrentSearchOperations : function(){
        this._currentSearchOperationId = null;
    },

    _isSearchOperationValid : function(operationId){
        return this._currentSearchOperationId === operationId;
    },

    _startNewSearchOperation : function(){
        const operationId = this._generateSearchOperationId();
        this._currentSearchOperationId = operationId;
        return operationId;
    },

    cancelOngoingSearchOperations: function(){
        this._invalidateCurrentSearchOperations();
    },

});

SequencerSearchWidget.SEARCH_TYPE = SEARCH_TYPE;
SequencerSearchWidget.MEDIA_ANALYSIS_REASON = MEDIA_ANALYSIS_REASON;

export default SequencerSearchWidget; 
